
import React from 'react'

import { Grid } from '@mui/material'
import { makeStyles } from '@mui/styles'
import './sartlar-kosullar.css'

const useStyles = makeStyles((theme) => {
  const classList = {
    paper: {
      margin: theme.spacing(16, 4)
    }
  }
  return classList
})

const SartlarVeKosullar = () => {
  const classes = useStyles()
  return (
    <>
      <Grid container component="main">
        <Grid item xs={12}>
          <div className={classes.paper}>
            <div>
              <p className="c13"><span className="c5 c12 c17">&#304;&#350; ORTAKLI&#286;I S&Ouml;ZLE&#350;MES&#304;</span></p>
              <p className="c13"><span className="c5 c12 c17">(&Ccedil;evrimi&ccedil;i Sipari&#351; &#304;&ccedil;in H&uuml;k&uuml;mve &#350;artlar)</span></p>
              <p className="c15"><span className="c5 c10" /></p>
            </div>
            <p className="c4"><span className="c5 c2">MADDE 1 -S&Ouml;ZLE&#350;MEN&#304;N TARAFLARI</span></p>
            <p className="c3"><span className="c5 c2" /></p>
            <p className="c4" id="h.gjdgxs">
              <span className="c2">1.1.</span>
              <span className="c1">
                Bu s&ouml;zle&#351;me, bir tarafta
                KOLAYYOLLA Teknoloji Hizmetleri Dijital Pazarlama ve Ticaret Anonim &#350;irketi (bundan sonra
                &ldquo;KOLAYYOLLA&rdquo; olarak an&#305;lacakt&#305;r) ile di&#287;er tarafta ise bu s&ouml;zle&#351;menin
                ayr&#305;lmaz bir par&ccedil;as&#305;n&#305; olu&#351;turan i&#351;yeri &uuml;yelik formunda tam unvan&#305;
                yer alan taraf (bundan sonra sat&#305;c&#305; ya da &uuml;ye i&#351; yeri olarak an&#305;lacakt&#305;r)
                aras&#305;nda a&#351;a&#287;&#305;da yaz&#305;l&#305; &#351;artlar d&acirc;hilinde
                akdedilmi&#351;tir.
              </span>
            </p>
            <p className="c3"><span className="c5 c2" /></p>
            <p className="c4"><span className="c5 c2">MADDE 2 -TARAFLARA &#304;L&#304;&#350;K&#304;N B&#304;LG&#304;LER</span></p>
            <p className="c3"><span className="c5 c2" /></p>
            <p className="c4">
              <span className="c2">2.1. S&ouml;zle&#351;menin bir taraf&#305; </span>
              <span className="c1">
                KOLAYYOLLA
                Teknoloji Hizmetleri Dijital Pazarlama ve Ticaret Anonim &#350;irketi olup di&#287;er taraf&#305;
                i&#351;yeri &uuml;yelik formunda tam unvan&#305; yaz&#305;l&#305; taraft&#305;r.

              </span>
            </p>
            <p className="c3"><span className="c5 c2" /></p>
            <p className="c4">
              <span className="c2">2.2.</span>
              <span className="c1">
                &nbsp;&#304;&#351;bu s&ouml;zle&#351;mede taraflar ,
                ayr&#305; ayr&#305; &ldquo;KOLAYYOLLA&rdquo;, &rdquo;sat&#305;c&#305;&rdquo; ve birlikte
                &ldquo;Taraflar&rdquo; olarak an&#305;lacakt&#305;r.
              </span>
            </p>
            <p className="c3"><span className="c5 c2" /></p>
            <p className="c4">
              <span className="c2">2.3. </span>
              <span className="c1">
                Her iki taraf belirtmi&#351; olduklar&#305; adreslerini
                tebligat adresleri olarak kabul etmi&#351;lerdir. Adres de&#287;i&#351;iklikleri usul&uuml;ne uygun
                &#351;ekilde yaz&#305;l&#305; olarak kar&#351;&#305; tarafa tebli&#287; edilmedik&ccedil;e en son bildirilen
                adrese yap&#305;lacak tebli&#287; ilgili tarafa yap&#305;lm&#305;&#351; say&#305;l&#305;r.
              </span>
            </p>
            <p className="c3"><span className="c5 c2" /></p>
            <p className="c4">
              <span className="c2">2.4.</span>
              <span className="c1">
                &nbsp;Taraflar, yaz&#305;l&#305; tebligat&#305; daha
                sonra s&uuml;resi i&ccedil;inde yapmak kayd&#305;yla, kurye, teyitli faks veya elektronik posta gibi
                di&#287;er yollarla da bildirim yapabilirler.
              </span>
            </p>
            <p className="c3"><span className="c5 c2" /></p>
            <p className="c4">
              <span className="c5 c2">MADDE 3- S&Ouml;ZLE&#350;MEDE TEMS&#304;L VE &#304;MZA YETK&#304;S&#304;</span>
            </p>
            <p className="c3"><span className="c5 c2" /></p>
            <p className="c4">
              <span className="c2">3.1.</span>
              <span className="c1">
                &nbsp;S&ouml;zle&#351;menin taraflar&#305;; bizzat
                &#351;irket yetkilileri, ticaret sicil gazetesinde resmi olarak g&ouml;revlendirilmi&#351; ger&ccedil;ek
                ki&#351;iler ya da usul&uuml;ne uygun bir &#351;ekilde d&uuml;zenlenmi&#351; vekaletnameye sahip vekiller
                taraf&#305;ndan temsil edilmektedir.

              </span>
            </p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4"><span className="c5 c2">MADDE 4 &ndash; TANIMLAR</span></p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4"><span className="c1">Bu S&ouml;zle&#351;me&#39;de yaz&#305;l&#305;; </span></p>
            <p className="c3"><span className="c5 c2" /></p>
            <p className="c4">
              <span className="c2">Platform </span>
              <span className="c1">
                : Mu&#776;lkiyeti ve 6769 say&#305;l&#305;
                S&#305;nai Mu&#776;lkiyet Kanunu ve 5846 say&#305;l&#305; Fikir ve Sanat Eserleri Kanunu uyar&#305;nca her
                tu&#776;rlu&#776; fikri ve s&#305;nai haklar&#305; KOLAYYOLLA&rsquo;ya ait olan ve is&#807;bu
                So&#776;zles&#807;me ile belirlenen &quot;Hizmetler&quot;in sunulmakta oldug&#774;u KOLAYYOLLA.app ve
                bag&#774;lant&#305;l&#305; tu&#776;m dig&#774;er alan adlar&#305;nda mevcut olan internet sitesi ile mobil
                uygulamay&#305; ve Sat&#305;c&#305;&rsquo;n&#305;n, Platform&rsquo;da sunulan uygulamalardan ve
                Hizmetler&rsquo;den yararlanabilmesi ic&#807;in gerekli is&#807;lemleri
                gerc&#807;ekles&#807;tirebildig&#774;i, kendisinden talep edilen firma/kis&#807;isel bilgilerini
                girdig&#774;i, sat&#305;s&#807; is&#807;lem detaylar&#305;n&#305; takip edebildig&#774;i, o&#776;zel sanal
                sayfay&#305; ifade eder.

              </span>
            </p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4">
              <span className="c2">Hizmet/Hizmetler </span>
              <span className="c1">
                : Sat&#305;c&#305;n&#305;n
                u&#776;ru&#776;nlerini kendi sayfalar&#305;nda yay&#305;mlayarak sat&#305;s&#807;a
                c&#807;&#305;karmalar&#305; amac&#305;yla KOLAYYOLLA taraf&#305;ndan Platform&rsquo;da sunulan
                sat&#305;s&#807;a arac&#305;l&#305;k/pazarlama ve benzeri sair tu&#776;m uygulamalar&#305; ifade
                eder.
              </span>
            </p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4">
              <span className="c2">Al&#305;c&#305; </span>
              <span className="c1">
                : Platform u&#776;zerinde Sat&#305;c&#305;
                taraf&#305;ndan verilen ilanlarla sat&#305;s&#807;a arz edilen mal ve/veya hizmetleri sat&#305;n alan
                gerc&#807;ek veya tu&#776;zel kis&#807;i U&#776;ye&rsquo;yi ifade eder.

              </span>
            </p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4">
              <span className="c2">Sat&#305;c&#305;</span>
              <span className="c1">
                : Platform u&#776;zerinde
                olus&#807;turdug&#774;u hesap u&#776;zerinden yay&#305;nlad&#305;g&#774;&#305; ilanlar
                arac&#305;l&#305;g&#774;&#305;yla c&#807;es&#807;itli &uuml;r&uuml;nleri sat&#305;s&#807;a arz eden
                tu&#776;zel/gerc&#807;ek kis&#807;i U&#776;ye&rsquo;yi ifade eder.
              </span>
            </p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4">
              <span className="c7">&nbsp;</span>
              <span className="c2">I&#775;s&#807;gu&#776;nu&#776; </span>
              <span
                className="c1"
              >
                : Pazar ve Resmi Tatiller haric&#807; haftan&#305;n dig&#774;er gu&#776;nlerini ifade
                eder.
              </span>
            </p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4"><span className="c5 c2">MADDE 5: S&Ouml;ZLE&#350;MEN&#304;N KONUSU VE KAPSAMI</span></p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4">
              <span className="c1">
                I&#775;s&#807;bu So&#776;zles&#807;me&rsquo;nin konusunu, Platform&rsquo;da
                KOLAYYOLLA taraf&#305;ndan sunulan Hizmetler&rsquo;den, Sat&#305;c&#305;&rsquo;n&#305;n yararlanmas&#305;na
                ilis&#807;kin s&#807;art ve kos&#807;ullar&#305;n belirlenmesi ve bu dog&#774;rultuda taraflar&#305;n hak ve
                yu&#776;ku&#776;mlu&#776;lu&#776;klerinin tespiti olus&#807;turmaktad&#305;r. Sat&#305;c&#305; ile
                Al&#305;c&#305;&rsquo;lar aras&#305;ndaki ilis&#807;ki is&#807;bu So&#776;zles&#807;me&rsquo;nin
                kapsam&#305;na girmemektedir; KOLAYYOLLA is&#807;bu ticari faaliyette sadece, Platform&rsquo;da
                Sat&#305;c&#305;&rsquo;lara u&#776;ru&#776;n/hizmet sat&#305;s&#807; hakk&#305; vermekte olup hic&#807;bir
                surette Sat&#305;c&#305; ile Al&#305;c&#305;&rsquo;lar aras&#305;ndaki so&#776;zles&#807;me ilis&#807;kisine
                taraf deg&#774;ildir. Sat&#305;c&#305;, Platform&rsquo;dan gerc&#807;ekles&#807;tireceg&#774;i
                sat&#305;s&#807; is&#807;lemlerinden, Al&#305;c&#305;&rsquo;lara kars&#807;&#305; mevcut mevzuat
                hu&#776;ku&#776;mleri c&#807;erc&#807;evesinde bizzat sorumlu olacakt&#305;r.

              </span>
            </p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4">
              <span className="c5 c2">
                MADDE 6: YORUM VE TEMEL
                H&Uuml;K&Uuml;MLER&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:
              </span>
            </p>
            <p className="c4"><span className="c1">&nbsp;</span></p>
            <p className="c4">
              <span className="c2">6.1. </span>
              <span className="c1">
                Bu S&ouml;zle&#351;me sat&#305;c&#305;ya; acentelik,
                komisyonculuk, tellall&#305;k, simsarl&#305;k, vekillik, ortakl&#305;k ve &Uuml;r&uuml;n&uuml; &uuml;retmek
                veya &uuml;rettirmek hakk&#305; vermez. KOLAYYOLLA, ba&#287;&#305;ms&#305;z bir tacir vasf&#305;n&#305; haiz
                olup, bu S&ouml;zle&#351;medeki hi&ccedil;bir h&uuml;k&uuml;m, taraflardan birini, di&#287;erinin acentesi,
                hukuki temsilcisi, orta&#287;&#305; veya m&uuml;&#351;terek i&#351; orta&#287;&#305; durumuna getirdi&#287;i
                veya z&#305;mni olarak di&#287;er taraf&#305; temsil etmek, di&#287;er taraf&#305;n nam veya hesab&#305;na
                ya da di&#287;er taraf&#305; ba&#287;layacak nitelikte taahh&uuml;tler &uuml;stlenmek veya bor&ccedil;
                alt&#305;na girmek yetkisi verdi&#287;i &#351;eklinde yorumlanamaz.
              </span>
            </p>
            <p className="c4"><span className="c5 c2">&nbsp;</span></p>
            <p className="c4">
              <span className="c2">6.2. </span>
              <span className="c1">
                Sat&#305;c&#305; bu s&ouml;zle&#351;meyi tamamen veya
                k&#305;smen KOLAYYOLLA&rsquo;n&#305;n yaz&#305;l&#305; onay&#305;n&#305; almaks&#305;z&#305;n
                &uuml;&ccedil;&uuml;nc&uuml; ki&#351;ilere devredemez, bu S&ouml;zle&#351;me&#39;nin h&uuml;k&uuml;mlerinin
                uygulanmas&#305; i&ccedil;in &uuml;&ccedil;&uuml;nc&uuml; ki&#351;ilerle ortakl&#305;klar kuramaz.
              </span>
            </p>
            <p className="c4"><span className="c5 c2">&nbsp;</span></p>
            <p className="c4"><span className="c5 c2">MADDE 7: S&Ouml;ZLE&#350;MEN&#304;N EKLER&#304;</span></p>
            <p className="c14" id="h.30j0zll">
              <span className="c1">
                S&ouml;zle&#351;menin ekinde bulunan t&uuml;m bilgi ve belgeler bu
                s&ouml;zle&#351;menin eki ve ayr&#305;lmaz par&ccedil;as&#305; olup, taraflar&#305; ba&#287;lar.

              </span>
            </p>
            <p className="c4"><span className="c5 c2">MADDE 8: S&Ouml;ZLE&#350;MEN&#304;N S&Uuml;RES&#304; VE FESH&#304;</span></p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4">
              <span className="c2">8.1.</span>
              <span className="c1">
                &nbsp;Taraflar, her zaman 45 g&uuml;n o&#776;nceden
                yaz&#305;l&#305; fesih ihbar&#305;nda bulunmak kayd&#305;yla is&#807;bu So&#776;zles&#807;me&rsquo;yi
                gerekc&#807;esiz ve tazminats&#305;z feshetme hakk&#305;na sahiptir. So&#776;zles&#807;me&rsquo;nin feshi
                durumunda, is&#807;bu So&#776;zles&#807;me&rsquo;deki gizlilik ve fikri mu&#776;lkiyet hu&#776;ku&#776;mleri
                bag&#774;lay&#305;c&#305;l&#305;g&#774;&#305;n&#305; koruyacakt&#305;r.

              </span>
            </p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4">
              <span className="c2">8.2.</span>
              <span className="c1">
                &nbsp;S&ouml;zle&#351;menin feshi, 45 g&uuml;nl&uuml;k
                ihbar s&uuml;resinin dolmas&#305; ile kar&#351;&#305;l&#305;kl&#305; olarak ger&ccedil;ekle&#351;ecektir.
              </span>
            </p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4">
              <span className="c2">8.3.</span>
              <span className="c1">
                &nbsp;Bu S&ouml;zle&#351;me&#39;nin feshi veya herhangi
                bir nedenle sona ermesi, taraflar&#305;n &ouml;nceki hak ve y&uuml;k&uuml;ml&uuml;l&uuml;klerini ortadan
                kald&#305;rmayaca&#287;&#305; gibi, bu S&ouml;zle&#351;me&#39;nin devaml&#305;l&#305;k arz eden
                h&uuml;k&uuml;mlerini de etkilemeyecektir.
              </span>
            </p>
            <p className="c3"><span className="c0" /></p>
            <p className="c4">
              <span className="c2">8.4.</span>
              <span className="c1">
                &nbsp;S&ouml;zle&#351;menin hakl&#305; bir sebeple
                KOLAYYOLLA taraf&#305;ndan feshi halinde KOLAYYOLLA do&#287;mu&#351; yada do&#287;acak t&uuml;m
                zararlar&#305;n&#305; sat&#305;c&#305;dan tazmin edebilece&#287;i gibi, s&ouml;zle&#351;medeki di&#287;er
                h&uuml;k&uuml;mlere ili&#351;kin tazminat taleplerini de sat&#305;c&#305;dan talep edebilecektir.
                Sat&#305;c&#305; bu husustaki t&uuml;m haklar&#305;ndan feragat etti&#287;ini kabul etmektedir.
              </span>
            </p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4"><span className="c5 c2">MADDE 9: TARAFLARIN HAK VE Y&Uuml;K&Uuml;ML&Uuml;L&Uuml;KLER&#304;</span></p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4"><span className="c2 c5">9.1. GENEL H&Uuml;K&Uuml;MLER</span></p>
            <p className="c3"><span className="c5 c2" /></p>
            <p className="c4">
              <span className="c2">9.1.</span>
              <span className="c1">
                &nbsp;Sat&#305;c&#305;, &quot;sat&#305;c&#305;&quot;
                s&#305;fat&#305;n&#305; kazanabilmek i&ccedil;in, &ouml;ncelikle &#304;&#350;YER&#304; &Uuml;YEL&#304;K
                FORMU&rsquo;nda yer alan bilgileri tam ve eksiksiz olarak dolduracakt&#305;r. Sat&#305;c&#305;
                taraf&#305;ndan i&#351;bu bilgiler eksiksiz olarak belirtilmekle birlikte, KOLAYYOLLA&rsquo;n&#305;n
                Sat&#305;c&#305;&rsquo;n&#305;n ba&#351;vurusunu sebep g&ouml;stermeksizin reddetme ve/veya ek belge talep
                etme hakk&#305; her zaman vard&#305;r.
              </span>
            </p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4">
              <span className="c2">9.2. </span>
              <span className="c1">
                Sat&#305;c&#305;, Platform&rsquo;da sat&#305;&#351;a
                sundu&#287;u t&uuml;m &uuml;r&uuml;nleri tam ve/veya gere&#287;i gibi eksiksiz ve her t&uuml;rl&uuml;
                a&ccedil;&#305;k, &ouml;rt&uuml;l&uuml; gizli ay&#305;ptan ari olarak Al&#305;c&#305;&rsquo;ya teslim etmeyi
                kabul, beyan ve taahh&uuml;t eder.
              </span>
            </p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4">
              <span className="c2">9.3.</span>
              <span className="c1">
                &nbsp;Sat&#305;c&#305;, her t&uuml;rl&uuml; reklam ve
                ilan&#305;n Platform&rsquo;da yay&#305;nlanmas&#305;n&#305; sa&#287;layacak gerekli teknik
                altyap&#305;n&#305;n olu&#351;turulmas&#305; i&ccedil;in KOLAYYOLLA ile tam i&#351; birli&#287;i
                i&ccedil;inde olmay&#305; ve bunun i&ccedil;in gerekli her t&uuml;rl&uuml; belgeyi temin etmeyi kabul, beyan
                ve taahh&uuml;t eder. KOLAYYOLLA m&uuml;nhas&#305;ran kendi takdirinde olmak &uuml;zere
                Sat&#305;c&#305;&rsquo;n&#305;n Platform&rsquo;daki herhangi bir &uuml;r&uuml;n&uuml;n&uuml; sebep
                g&ouml;stermeksizin sat&#305;&#351;a kapatma hak ve yetkisine sahiptir.
              </span>
            </p>
            <p className="c4"><span className="c1">&nbsp;</span></p>
            <p className="c4">
              <span className="c2">9.4.</span>
              <span className="c1">
                &nbsp;G&ouml;rsellerin Sat&#305;c&#305; taraf&#305;ndan
                KOLAYYOLLA&rsquo;ya verilmesi halinde Sat&#305;c&#305; &uuml;r&uuml;n g&ouml;rsellerinin 5846
                say&#305;l&#305; Fikir ve Sanat Eserleri Kanunu (&ldquo;FSEK&rdquo;) uyar&#305;nca eser niteli&#287;ini haiz
                olmas&#305; halinde FSEK&rsquo;in 21. maddesindeki i&#351;leme, 22. maddesindeki &ccedil;o&#287;altma, 23.
                maddesindeki yayma, 24. maddesindeki temsil, 25. maddesindeki i&#351;aret, ses ve/veya
                g&ouml;r&uuml;nt&uuml; nakline yarayan ara&ccedil;larla umuma iletim hakk&#305; S&ouml;zle&#351;me
                s&uuml;resiyle s&#305;n&#305;rl&#305; olarak herhangi bir mecra ve &uuml;lke s&#305;n&#305;rlamas&#305;
                olmaks&#305;z&#305;n KOLAYYOLLA&rsquo;ya &uuml;&ccedil;&uuml;nc&uuml; ki&#351;ilere de
                kulland&#305;rabilecek &#351;ekilde basit ruhsat verdi&#287;ini/verece&#287;ini kabul, beyan ve taahh&uuml;t
                eder.
              </span>
            </p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4">
              <span className="c2">9.5.</span>
              <span className="c1">
                &nbsp;Sat&#305;c&#305;, Platform&rsquo;da
                yay&#305;nlad&#305;&#287;&#305; ilanlara y&ouml;nelik her t&uuml;rl&uuml; g&ouml;rsel, yaz&#305;l&#305; ve
                sair sa&#287;lanan fiyat/ilan/bilgi/i&ccedil;eriklerin ger&ccedil;ekli&#287;inden, g&uuml;venli&#287;inden,
                do&#287;rulu&#287;undan ve hukuka uygunlu&#287;undan bizzat sorumlu olmay&#305;; bu bilgi ve belgeleri
                ba&#351;ta entegrat&ouml;rler olmak &uuml;zere &uuml;&ccedil;&uuml;nc&uuml; ki&#351;ilerle do&#287;ru ve
                g&uuml;ncel &#351;ekilde payla&#351;may&#305; aksi halde KOLAYYOLLA&rsquo;n&#305;n bu hususlarda herhangi
                bir sorumlulu&#287;u olmad&#305;&#287;&#305;n&#305; kabul, beyan ve taahh&uuml;t eder.
              </span>
            </p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4">
              <span className="c2">9.6.</span>
              <span className="c1">
                &nbsp;Sat&#305;c&#305;, Platform&rsquo;da ve ilanlarda
                sergiledi&#287;i mallar&#305;n sat&#305;&#351;&#305;n&#305;n ve te&#351;hirinin y&uuml;r&uuml;rl&uuml;kteki
                mevzuatlar do&#287;rultusunda herhangi bir hukuka ayk&#305;r&#305;l&#305;k yaratmayaca&#287;&#305;n&#305;,
                hak ihlaline sebep olmayaca&#287;&#305;n&#305;, s&ouml;z konusu ilan ve i&ccedil;eriklerin ilgili
                oldu&#287;u mal ve hizmetlerin internet &uuml;zerinde yay&#305;nlanmas&#305;, sat&#305;&#351;a arz edilmesi
                ve sat&#305;lmas&#305; i&ccedil;in t&uuml;m hak, yetki ve sorumlulu&#287;un kendisinde oldu&#287;unu kabul,
                beyan ve taahh&uuml;t etmektedir. Ayr&#305;ca Sat&#305;c&#305;, ilgili kurumlar&#305;n ve mevzuatlar&#305;n
                sat&#305;&#351;&#305; yasakl&#305; olanlar listelerini s&uuml;rekli olarak takip etmek ve bu listede yer
                alan &uuml;r&uuml;nlerin te&#351;hirini ve sat&#305;&#351;&#305;n&#305; yapmamakla
                y&uuml;k&uuml;ml&uuml;d&uuml;r.
              </span>
            </p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4">
              <span className="c2">9.7.</span>
              <span className="c1">
                &nbsp;Sat&#305;c&#305;, KOLAYYOLLA.app&rsquo;a &uuml;ye
                oldu&#287;u esnada bir kullan&#305;c&#305; ad&#305; ve &#351;ifre olu&#351;turacak; profil sayfas&#305;na
                eri&#351;mek ve di&#287;er baz&#305; i&#351;lemleri ger&ccedil;ekle&#351;tirebilmek i&ccedil;in bu bilgileri
                kullanacakt&#305;r. Sat&#305;c&#305;&rsquo;n&#305;n &#351;ifre ve kullan&#305;c&#305; ad&#305;n&#305;n
                g&uuml;venli&#287;i ve gizlili&#287;i tamamen Sat&#305;c&#305;&rsquo;n&#305;n sorumlulu&#287;undad&#305;r.
                Sat&#305;c&#305; kendi profili &uuml;zerinden giri&#351; yap&#305;larak ger&ccedil;ekle&#351;tirilen
                i&#351;lemlerin yetkisiz i&#351;lem oldu&#287;undan kaynakl&#305; olarak ge&ccedil;ersizli&#287;ini ileri
                s&uuml;rme hakk&#305;ndan pe&#351;inen feragat etmi&#351;tir. Bu t&uuml;r i&#351;lemlerde dahi, her
                t&uuml;rl&uuml; sorumluluk Sat&#305;c&#305;&rsquo;n&#305;n kendisine ait olacakt&#305;r.
                Sat&#305;c&#305;&rsquo;n&#305;n &#351;ifresi kullan&#305;larak KOLAYYOLLA.app&rsquo;ta KOLAYYOLLA aleyhine
                veya zarar&#305;na i&#351;lem yap&#305;lmas&#305; halinde; Sat&#305;c&#305;, KOLAYYOLLA&rsquo;n&#305;n bu
                fiillerden do&#287;an zararlar&#305;n&#305; kar&#351;&#305;lamakla m&uuml;kelleftir.
              </span>
            </p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4">
              <span className="c2">9.8.</span>
              <span className="c1">
                &nbsp;KOLAYYOLLA, Sat&#305;c&#305; taraf&#305;ndan
                &Uuml;yelik i&#351;lemi esnas&#305;nda ve &Uuml;yelik boyunca temin edilen &#351;ahsi ve ticari bilgileri
                g&uuml;venli bir ortamda saklayacakt&#305;r. KOLAYYOLLA, bu bilgileri Hizmetler&rsquo;in tam ve gere&#287;i
                gibi i&#351;letilmesi i&ccedil;in gereken uygulamalar&#305;n y&uuml;r&uuml;t&uuml;lmesi, istatistiki
                de&#287;erlendirmelerin yap&#305;lmas&#305; amac&#305;yla KOLAYYOLLA ve i&#351; ortaklar&#305;n&#305;n
                faaliyetlerinin, uygulamalar&#305;n&#305;n reklam&#305; &amp; pazarlanmas&#305;, ilan&#305; ve sair
                ama&ccedil;larla, kullanabilir ve yaln&#305;zca yukar&#305;da belirtilen sebeplerle anonim olarak
                &uuml;&ccedil;&uuml;nc&uuml; ki&#351;ilere a&ccedil;&#305;klanabilir. Sat&#305;c&#305;, kendine ait
                bilgilerin KOLAYYOLLA taraf&#305;ndan i&#351;bu madde h&uuml;km&uuml;ne g&ouml;re kullan&#305;m&#305;na ve
                saklanmas&#305;na r&#305;za g&ouml;sterdi&#287;ini kabul ve beyan eder.
              </span>
            </p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4">
              <span className="c2">9.9.</span>
              <span className="c1">
                &nbsp;Sat&#305;c&#305;, Platform&rsquo;da
                y&uuml;r&uuml;tt&uuml;&#287;&uuml; t&uuml;m faaliyetlerini Platform&rsquo;a teknik olarak hi&ccedil;bir
                surette zarar vermeyecek &#351;ekilde y&uuml;r&uuml;tmekle y&uuml;k&uuml;ml&uuml;d&uuml;r. Sat&#305;c&#305;,
                Platform&rsquo;a sa&#287;layaca&#287;&#305; t&uuml;m bilgi, i&ccedil;erik, materyal ve sair
                i&ccedil;eri&#287;in sisteme zarar verecek her t&uuml;rl&uuml; program, vir&uuml;s, yaz&#305;l&#305;m,
                lisans&#305;z &uuml;r&uuml;n, truva at&#305;, vb. gibi i&ccedil;ermemesi i&ccedil;in gerekli her
                t&uuml;rl&uuml; tedbiri (gerekli koruyucu yaz&#305;l&#305;mlar&#305;n&#305; ve lisansl&#305;
                &uuml;r&uuml;nleri kullanmak da d&acirc;hil olmak &uuml;zere) ald&#305;&#287;&#305;n&#305;, bu madde
                h&uuml;km&uuml;n&uuml;n uygulanmas&#305; amac&#305;yla KOLAYYOLLA taraf&#305;ndan talep edilen
                &ouml;nlemleri derhal almay&#305; kabul, beyan ve taahh&uuml;t eder.
              </span>
            </p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4">
              <span className="c2">9.10.</span>
              <span className="c1">
                &nbsp;KOLAYYOLLA Platform&rsquo;un tam ve gere&#287;i
                gibi &ccedil;al&#305;&#351;abilmesi i&ccedil;in Platform&rsquo;da her t&uuml;rl&uuml; de&#287;i&#351;iklik
                yapma hakk&#305;na sahiptir. &#304;&#351;bu ama&ccedil;la KOLAYYOLLA, sunulan hizmetleri ve
                i&ccedil;erikleri her zaman ve hi&ccedil;bir bildirimde bulunmadan de&#287;i&#351;tirme hakk&#305;na
                sahiptir.
              </span>
            </p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4">
              <span className="c2">9.11.</span>
              <span className="c1">
                &nbsp;Sat&#305;c&#305;, Platform&rsquo;da
                yay&#305;nlad&#305;&#287;&#305; t&uuml;m ilanlarla ve i&ccedil;eriklerle ba&#287;l&#305;d&#305;r ve
                bunlardan kaynaklanan t&uuml;m taahh&uuml;tlerinden sorumlu olacakt&#305;r. KOLAYYOLLA,
                Sat&#305;c&#305;&rsquo;n&#305;n faaliyetlerinin i&#351;bu S&ouml;zle&#351;me ko&#351;ullar&#305;na ve
                Platform&rsquo;da beyan edilen kural ve &#351;artlara uymamas&#305;, mevzuata ayk&#305;r&#305;l&#305;k
                te&#351;kil etmesi, hukuki, teknik ve &ouml;zellikle bilgi g&uuml;venli&#287;i anlam&#305;nda risk
                olu&#351;turdu&#287;unun tespit edilmesi, &uuml;&ccedil;&uuml;nc&uuml; ki&#351;ilerin &#351;ahsi ve ticari
                haklar&#305;na halel getirici mahiyette olmas&#305; sebebiyle, Sat&#305;c&#305;&rsquo;ya herhangi bir
                &ouml;n ihtarda bulunmadan ilgili ilanlar&#305;n yay&#305;n&#305;n&#305; ge&ccedil;ici veya s&uuml;rekli
                olarak durdurabilir, &uuml;yeli&#287;i ask&#305;ya alabilir veya &uuml;yeli&#287;e son verebilir ve
                i&#351;bu S&ouml;zle&#351;meyi tazminats&#305;z olarak tek tarafl&#305; olarak feshedebilir,
                Sat&#305;c&#305;&rsquo;n&#305;n &uuml;r&uuml;n/hizmet sat&#305;&#351;&#305;n&#305; sona erdirebilir.
                Sat&#305;c&#305; b&ouml;yle bir durumda KOLAYYOLLA&rsquo;den herhangi bir &uuml;cret ve sair tazminat talep
                etmemeyi kabul, beyan ve taahh&uuml;t eder. &#304;&#351;bu madde h&uuml;km&uuml;ne ayk&#305;r&#305;l&#305;k
                halinde, KOLAYYOLLA&rsquo;nin herhangi bir ihtarda bulunmaks&#305;z&#305;n S&ouml;zle&#351;me&rsquo;yi
                istedi&#287;i zaman tek tarafl&#305; fesih hakl&#305; sakl&#305;d&#305;r.
              </span>
            </p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4">
              <span className="c2">9.12.</span>
              <span className="c1">
                &nbsp;Sat&#305;c&#305;, Al&#305;c&#305;lar&rsquo;la
                Platform&rsquo;dan yap&#305;lacak sat&#305;&#351;larda akdedilecek mesafeli sat&#305;&#351;
                s&ouml;zle&#351;melerinde Sat&#305;c&#305; taraf oldu&#287;unu, KOLAYYOLLA&rsquo;nin i&#351;bu mesafeli
                sat&#305;&#351; s&ouml;zle&#351;mesi ili&#351;kisinde taraf olmad&#305;&#287;&#305;n&#305;,
                Al&#305;c&#305;lar&rsquo;a kar&#351;&#305; y&uuml;r&uuml;rl&uuml;kteki t&uuml;ketici hukuku mevzuat&#305; ve
                sair mevzuat kapsam&#305;nda her anlamda bizzat sorumlu oldu&#287;unu kabul ve beyan eder. Sat&#305;c&#305;
                buna ek olarak, Platform&rsquo;da sergiledi&#287;i ve satt&#305;&#287;&#305; t&uuml;m &uuml;r&uuml;nlerin
                kalitesinden, mevzuata uygunlu&#287;undan, teslimat&#305;ndan bizzat sorumludur. Bu madde h&uuml;km&uuml;ne
                ayk&#305;r&#305;l&#305;k durumunda ortaya &ccedil;&#305;kabilecek zararlardan Sat&#305;c&#305; do&#287;rudan
                sorumlu olacakt&#305;r. Sat&#305;c&#305;, Platform&rsquo;dan sat&#305;&#351;&#305;n&#305;
                yapt&#305;&#287;&#305; &uuml;r&uuml;nlerin sat&#305;&#351; i&#351;lemi esnas&#305;nda belirtildi&#287;i
                teslim s&uuml;resinde Al&#305;c&#305;&rsquo;ya ula&#351;mas&#305;n&#305; sa&#287;layacak ve gecikmeden
                dolay&#305; her t&uuml;rl&uuml; sorumluluk da kendisinde olacakt&#305;r. Sat&#305;c&#305;, Al&#305;c&#305;
                istek ve taleplerine m&uuml;mk&uuml;n olan en k&#305;sa s&uuml;rede d&ouml;n&uuml;&#351; yapmak
                zorundad&#305;r.
              </span>
            </p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4">
              <span className="c2">9.13.</span>
              <span className="c1">
                &nbsp;Sat&#305;c&#305;, Al&#305;c&#305;&rsquo;yla
                yaln&#305;zca Platform &uuml;zerinden s&ouml;zle&#351;me akdedecek ve sadece Platform &uuml;zerinden
                s&ouml;z konusu ticari faaliyette bulunacakt&#305;r. Sat&#305;c&#305;, Al&#305;c&#305;&rsquo;n&#305;n
                Platform&rsquo;dan iletece&#287;i, kendisiyle her ne surette olursa olsun Platform d&#305;&#351;&#305;nda
                ileti&#351;ime ge&ccedil;me ve/veya Al&#305;c&#305;&rsquo;n&#305;n Platform d&#305;&#351;&#305;nda
                sat&#305;n alma iste&#287;ine olumlu cevap vermeyecek, her ne surette olursa olsun
                Al&#305;c&#305;lar&rsquo;la Platform d&#305;&#351;&#305;nda herhangi bir hukuki ili&#351;ki kurmayacak,
                herhangi bir sat&#305;&#351; i&#351;lemi ger&ccedil;ekle&#351;tirmeyecektir. Sat&#305;c&#305;
                KOLAYYOLLA&rsquo;nin bilgisi olmaks&#305;z&#305;n her ne surette olursa olsun Al&#305;c&#305;&rsquo;larla
                ileti&#351;ime ge&ccedil;meyecektir. &#350;u kadar ki Al&#305;c&#305;lar&rsquo;&#305;n do&#287;rudan
                Sat&#305;c&#305;&rsquo;ya ait al&#305;&#351;veri&#351; kanallar&#305;ndan ileti&#351;ime ge&ccedil;mesi
                i&#351;bu maddenin istisnas&#305;d&#305;r.
              </span>
            </p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4">
              <span className="c2">9.14.</span>
              <span className="c1">
                &nbsp;KOLAYYOLLA taraf&#305;ndan
                Sat&#305;c&#305;&rsquo;n&#305;n herhangi bir sebeple &uuml;yeli&#287;inin ask&#305;ya al&#305;nmas&#305;
                veya &uuml;yelikten &ccedil;&#305;kar&#305;larak bir daha KOLAYYOLLA platformlar&#305;na al&#305;nmamak
                &uuml;zere kara listeye al&#305;nmas&#305; halinde Sat&#305;c&#305;, ba&#351;ka bir kullan&#305;c&#305;
                hesab&#305;yla Platform&rsquo;a &uuml;ye olamaz. Sat&#305;c&#305;&rsquo;n&#305;n bu madde h&uuml;km&uuml;ne
                ayk&#305;r&#305; olarak Platform&rsquo;a &uuml;ye olmas&#305; ve durumun tespiti halinde Sat&#305;c&#305;,
                &uuml;yelikten yeniden &ccedil;&#305;kart&#305;lacakt&#305;r.
              </span>
            </p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4">
              <span className="c2">9.15.</span>
              <span className="c1">
                &nbsp;Sat&#305;c&#305; 213 Say&#305;l&#305; Vergi Usul
                Kanunu m. 230 ve 3065 Say&#305;l&#305; Katma De&#287;er Vergisi Kanunu m. 8. uyar&#305;nca sat&#305;lan veya
                sa&#287;lanan &uuml;r&uuml;n ve hizmetle ilgili fatura veya perakende sat&#305;&#351; fi&#351;i
                d&uuml;zenlemek zorundad&#305;r. Sat&#305;c&#305; ; Al&#305;c&#305;&rsquo;ya g&ouml;nderdi&#287;i mal
                ve/veya hizmeti fatura keserek teslim etmeyi, ba&#351;ta 6502 Say&#305;l&#305; T&uuml;keticinin
                Korunmas&#305;
              </span>
            </p>
            <p className="c4">
              <span className="c1">
                Hakk&#305;nda Kanun olmak &uuml;zere sair mevzuattan kaynaklanan
                y&uuml;k&uuml;ml&uuml;l&uuml;klerini eksiksiz yerine getirmeyi, ayr&#305;ca Sat&#305;c&#305;&rsquo;n&#305;n
                i&#351;bu y&uuml;k&uuml;ml&uuml;l&uuml;klerini gere&#287;i gibi yerine getirmemesiyle sebebiyle
                KOLAYYOLLA&rsquo;nin u&#287;rad&#305;&#287;&#305; zararlar ve masraflar&#305; (mahkeme masraflar&#305;, para
                cezalar&#305;, vergi, resim, har&ccedil; dahil fakat bunlarla s&#305;n&#305;rl&#305; olmamak &uuml;zere her
                t&uuml;rl&uuml; giderler) nakden ve defaten &ouml;demeyi kabul, beyan ve taahh&uuml;t eder.
              </span>
            </p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4">
              <span className="c2">9.16.</span>
              <span className="c1">
                &nbsp;Platform&rsquo;dan sunulacak olan
                Hizmetler&rsquo;in ve KOLAYYOLLA taraf&#305;ndan uygulanan kampanyalar&#305;n detaylar&#305;,
                &uuml;r&uuml;nlerin sergilenme s&uuml;releri ve teknik &ouml;zellikler gibi ikincil de&#287;i&#351;iklikler
                KOLAYYOLLA taraf&#305;ndan her zaman de&#287;i&#351;tirilebilecektir. &#350;u kadar ki, Taraflar&rsquo;ca
                aksi y&ouml;nde bir anla&#351;ma olmaks&#305;z&#305;n KOLAYYOLLA fiyat bilgilerini
                de&#287;i&#351;tiremez.
              </span>
            </p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4">
              <span className="c2">9.17.</span>
              <span className="c1">
                &nbsp;Sat&#305;c&#305; ayr&#305;ca &ouml;ncesinde
                KOLAYYOLLA&rsquo;nin yaz&#305;l&#305; izni olmaks&#305;z&#305;n Al&#305;c&#305;&rsquo;lara herhangi bir
                reklam ve/veya pazarlama &ccedil;al&#305;&#351;mas&#305; yapamayacak (&uuml;r&uuml;n&uuml;n
                Sat&#305;c&#305;&rsquo;lara ait kutularla g&ouml;nderilmesi d&#305;&#351;&#305;nda),
                Al&#305;c&#305;&rsquo;lara &uuml;r&uuml;n ve/veya hizmetle birlikte herhangi bir promosyon malzemesi, numune
                &uuml;r&uuml;n gibi bir g&ouml;nderide bulunmayacakt&#305;r. Sat&#305;c&#305; aksi halde KOLAYYOLLA
                taraf&#305;ndan belirlenecek cezai &#351;art oran&#305;nda &ouml;demeyi kabul, beyan ve taahh&uuml;t
                eder.
              </span>
            </p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4">
              <span className="c2">9.18.</span>
              <span className="c1">
                &nbsp;Sat&#305;c&#305; 5464 say&#305;l&#305; Banka
                Kartlar&#305; ve Kredi Kartlar&#305; Kanununa, 5651 say&#305;l&#305; &#304;nternet Ortam&#305;nda
                Yap&#305;lan Yay&#305;nlar&#305;n D&uuml;zenlenmesi ve Bu Yay&#305;nlar Yoluyla &#304;&#351;lenen
                Su&ccedil;larla M&uuml;cadele Edilmesi Hakk&#305;nda Kanuna, 6493 say&#305;l&#305; &Ouml;deme ve Menkul
                K&#305;ymet Mutabakat Sistemleri, &Ouml;deme Hizmetleri ve Elektronik Para Kurulu&#351;lar&#305;
                Hakk&#305;nda Kanuna, 6502 say&#305;l&#305; T&uuml;keticinin Korunmas&#305; Hakk&#305;nda Kanuna, 6563
                say&#305;l&#305; Elektronik Ticaretin D&uuml;zenlenmesi Hakk&#305;nda Kanuna, 6698 say&#305;l&#305;
                Ki&#351;isel Verilerin Korunmas&#305; Kanunu ve bu kanunlar&#305;n ikincil d&uuml;zenlemeleri ba&#351;ta
                olmak &uuml;zere y&uuml;r&uuml;rl&uuml;kteki t&uuml;m mevzuata uygun hareket edece&#287;ini, elektronik
                ticaret ortam&#305;nda sat&#305;&#351;&#305; yasak olan ya da &#351;arta ba&#287;lanan &uuml;r&uuml;nlere
                ili&#351;kin d&uuml;zenleme ve idari kararlara uygun davranaca&#287;&#305;n&#305; gayrikabili r&uuml;cu
                kabul, beyan ve taahh&uuml;t eder. Sat&#305;c&#305; ayr&#305;ca 5996 say&#305;l&#305; Veteriner Hizmetleri,
                Bitki Sa&#287;l&#305;&#287;&#305;, G&#305;da ve Yem Kanunu ba&#351;ta olmak &uuml;zere g&#305;da
                mevzuat&#305;yla ilgili t&uuml;m ikincil mevzuata ve g&#305;da kodeksine uygun hareket edece&#287;ini,
                T&uuml;rk G&#305;da Kodeksi G&#305;da Etiketleme ve T&uuml;keticileri Bilgilendirme Y&ouml;netmeli&#287;i
                uyar&#305;nca gerek Platform &uuml;zerinden gerekse de &uuml;r&uuml;nlerin teslimi s&#305;ras&#305;nda
                &uuml;r&uuml;nlerle ilgili bilgilendirme y&uuml;k&uuml;ml&uuml;l&uuml;&#287;&uuml;n&uuml;n tam ve eksiksiz
                olarak yap&#305;lmas&#305;ndan m&uuml;nhas&#305;ran sorumlu oldu&#287;unu, KOLAYYOLLA&rsquo;nin bu hususta
                herhangi bir sorumlulu&#287;u bulunmad&#305;&#287;&#305;n&#305;, KOLAYYOLLA&rsquo;yi her t&uuml;rl&uuml; 3.
                Ki&#351;i talebinden ari tutaca&#287;&#305;n&#305;, i&#351;bu y&uuml;k&uuml;ml&uuml;l&uuml;&#287;e
                ayk&#305;r&#305; davranmas&#305; halinde KOLAYYOLLA&rsquo;nin u&#287;rad&#305;&#287;&#305; her
                t&uuml;rl&uuml; zarar&#305; tazmin edece&#287;ini gayrikabili r&uuml;cu kabul, beyan ve taahh&uuml;t
                eder.
              </span>
            </p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4">
              <span className="c2">9.19.</span>
              <span className="c1">
                &nbsp;Sat&#305;c&#305;, Platform&rsquo;dan
                sat&#305;&#351;a sunaca&#287;&#305; &uuml;r&uuml;nlerin &uuml;zerinde bulunan 6769 say&#305;l&#305;
                S&#305;nai M&uuml;lkiyet Kanunu (&ldquo;SMK&rdquo;) anlam&#305;nda s&#305;nai m&uuml;lkiyet
                unsurlar&#305;n&#305;n, i) kendisine ait oldu&#287;unu; veya ii) bu &uuml;r&uuml;nleri
                Al&#305;c&#305;&rsquo;ya satma konusunda yetkili oldu&#287;unu; veya iii) SMK&rsquo;n&#305;n 152. maddesi
                (veya ileride bu alanda d&uuml;zenlenecek yeni kanun ve y&ouml;netmelik maddelerine uygun olarak) ve sair
                maddeleri uyar&#305;nca &uuml;zerlerindeki marka/tasar&#305;m hakk&#305; t&uuml;kenmi&#351;
                &uuml;r&uuml;nler oldu&#287;unu, &uuml;r&uuml;nlerin ayr&#305;ca 5846 say&#305;l&#305; Fikir ve Sanat
                Eserleri Kanunu uyar&#305;nca eser niteli&#287;ini haiz olmas&#305; halinde eser sahibinin bizzat kendisi
                oldu&#287;unu ve/veya &uuml;r&uuml;nleri eser sahibinin r&#305;zas&#305; ile Platform&rsquo;da
                sat&#305;&#351;a sundu&#287;unu, &uuml;&ccedil;&uuml;nc&uuml; ki&#351;ilerin eserden do&#287;an
                haklar&#305;na tecav&uuml;z etmedi&#287;ini, KOLAYYOLLA&rsquo;nin &uuml;r&uuml;nler &uuml;zerinde herhangi
                bir inceleme y&uuml;k&uuml;ml&uuml;l&uuml;&#287;&uuml;n&uuml;n bulunmad&#305;&#287;&#305;n&#305;,
                KOLAYYOLLA&rsquo;ye &uuml;r&uuml;nlerle ilgili herhangi bir 3. Ki&#351;i talebinin gelmesi halinde derhal bu
                durumu ortaya koyan t&uuml;m belgeleri ve fatura silsilesini (kendisinden ba&#351;layarak geriye do&#287;ru
                marka sahibi veya onun r&#305;zas&#305; ile &uuml;r&uuml;nleri piyasaya sunmu&#351; ki&#351;ilerin
                faturas&#305;na kadar) eksiksiz derhal KOLAYYOLLA&rsquo;ye temin edece&#287;ini aksi halde
                KOLAYYOLLA&rsquo;nin Sat&#305;c&#305;&rsquo;n&#305;n Platform&rsquo;daki t&uuml;m
                sat&#305;&#351;lar&#305;n&#305; durdurma hakk&#305;n&#305;n oldu&#287;unu kabul, beyan ve taahh&uuml;t
                eder.
              </span>
            </p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4">
              <span className="c2">9.20.</span>
              <span className="c1">
                &nbsp;Sat&#305;c&#305;&rsquo;n&#305;n i&#351;bu
                S&ouml;zle&#351;me ve/veya eklerindeki herhangi bir y&uuml;k&uuml;ml&uuml;l&uuml;&#287;&uuml;n&uuml; tam
                ve/veya hi&ccedil; yerine getirememesi halinde KOLAYYOLLA u&#287;rad&#305;&#287;&#305; her t&uuml;rl&uuml;
                zarar&#305;n tazminini talep etme hakk&#305;na sahiptir. KOLAYYOLLA bu bedelleri
                Sat&#305;c&#305;&rsquo;n&#305;n herhangi bir alaca&#287;&#305;ndan mahsup edebilecektir.
              </span>
            </p>
            <p className="c3"><span className="c5 c2" /></p>
            <p className="c4"><span className="c5 c2">MADDE 10 &ndash; KUMPARA KULLANIMI VE &#350;ARTLARI</span></p>
            <p className="c3"><span className="c5 c2" /></p>
            <p className="c4"><span className="c5 c2">10.1. TANIMLAR: </span></p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4">
              <span className="c2">10.1.1.</span>
              <span className="c7">
                &nbsp;KUMPARA: KOLAYYOLLA ile s&ouml;zle&#351;me
                imzalam&#305;&#351; olan i&#351;letmelerin m&uuml;&#351;terilerine yapt&#305;klar&#305;
                al&#305;&#351;veri&#351;leri kar&#351;&#305;l&#305;&#287;&#305;nda kazand&#305;rd&#305;klar&#305; sadakat
                puan&#305;d&#305;r.

              </span>
            </p>
            <p className="c3"><span className="c6 c8" /></p>
            <p className="c4">
              <span className="c2">10.1.2.</span>
              <span className="c1">
                &nbsp;HO&#350; GELD&#304;N
                S&#304;PAR&#304;&#350;&#304;: Al&#305;c&#305;lar&#305;n, platformda sat&#305;&#351; yapan bir
                sat&#305;c&#305;dan verdikleri ilk paket sipari&#351;i
              </span>
            </p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4">
              <span className="c2">10.1.3.</span>
              <span className="c1">
                &nbsp;Biriktiren S&#304;PAR&#304;&#350;:
                Al&#305;c&#305;lar&#305;n platformda sat&#305;&#351; yapan bir sat&#305;c&#305;dan al&#305;nan puanlar&#305;
                kullanamad&#305;&#287;&#305; ancak puan kazand&#305;&#287;&#305; sipari&#351;.

              </span>
            </p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4"><span className="c5 c2">10.2. &#350;ARTLAR, KAZANIM VE KULLANIMI</span></p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4">
              <span className="c2">10.2.1.</span>
              <span className="c1">
                &nbsp;Sat&#305;c&#305;, kendi sayfas&#305;ndan
                olu&#351;turulan sipari&#351;lerde al&#305;c&#305;lar&#305;n verece&#287;i HO&#350; GELD&#304;N
                S&#304;PAR&#304;&#350;&#304; i&ccedil;in al&#305;c&#305;ya minimum %50 KUMPARA
                kazand&#305;raca&#287;&#305;n&#305; kabul ve taahh&uuml;t etmektedir. Bu tutar sat&#305;c&#305;n&#305;n
                kendi insiyatifinde olmak kayd&#305;yla artt&#305;r&#305;labilir.
              </span>
            </p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4">
              <span className="c2">10.2.2.</span>
              <span className="c1">
                &nbsp;Sat&#305;c&#305;, minimum kumpara oran&#305;ndan
                d&uuml;&#351;&uuml;k olmamas&#305; kayd&#305;yla kendi belirledi&#287;i oranlarda al&#305;c&#305;lar&#305;n
                Biriktiren sipari&#351;lerinden KUMPARA kazanacaklar&#305;n&#305; taahh&uuml;t eder.
              </span>
            </p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4">
              <span className="c2">10.2.3.</span>
              <span className="c1">
                &nbsp;Al&#305;c&#305;lar&#305;n sat&#305;c&#305;
                nezdinde olu&#351;turduklar&#305; sipari&#351;i teslim al&#305;p &ouml;demelerini yapmalar&#305; ve
                sipari&#351; durumunun i&#351;letme panelinde &ldquo;sipari&#351; teslim edildi&rdquo; a&#351;amas&#305;na
                geldi&#287;i anda al&#305;c&#305;n&#305;n hak etmi&#351; oldu&#287;u KUMPARA miktar&#305;
                al&#305;c&#305;n&#305;n sat&#305;c&#305; nezdindeki KUMPARA hesab&#305;na yans&#305;t&#305;lacak olup bu
                husus sat&#305;c&#305;n&#305;n kabul&uuml;ndedir.

              </span>
            </p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4">
              <span className="c2">10.2.4.</span>
              <span className="c1">
                &nbsp;&#304;lk sipari&#351;ten sonra devam eden
                sipari&#351;lerde al&#305;c&#305;lar taraf&#305;ndan kazan&#305;lacak minimum KUMPARA oran&#305;
                sat&#305;c&#305; ile imzalanm&#305;&#351; olan i&#351;yeri &uuml;yelik formunda belirtilen oranlardan
                d&uuml;&#351;&uuml;k olamayaca&#287;&#305; gibi sat&#305;c&#305;n&#305;n daha y&uuml;ksek bir oranda KUMPARA
                kazand&#305;rma politikas&#305; izleme y&ouml;n&uuml;nden serbestisi bulunmaktad&#305;r. Sat&#305;c&#305;,
                al&#305;c&#305;n&#305;n tercih edece&#287;i &uuml;r&uuml;nlerde belirtilen oranlar&#305; sayfas&#305;nda
                yay&#305;nlayaca&#287;&#305;n&#305; kabul etmektedir.
              </span>
            </p>
            <p className="c3"><span className="c0" /></p>
            <p className="c4">
              <span className="c2">10.2.5.</span>
              <span className="c1">
                &nbsp;Al&#305;c&#305; taraf&#305;ndan verilen tekrar
                eden sipari&#351;lerde al&#305;c&#305;n&#305;n kazanaca&#287;&#305; toplam KUMPARA oran&#305;
                sat&#305;c&#305; taraf&#305;ndan platformda kendilerine ayr&#305;lm&#305;&#351; olan panelde
                ayarlanabilece&#287;i gibi sat&#305;c&#305;lar istedikleri oranlar&#305; da s&ouml;zle&#351;menin
                10.2.4.maddesinin dikkate al&#305;nmas&#305; &#351;art&#305;yla belirleyebileceklerdir.

              </span>
            </p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4">
              <span className="c2">10.2.6.</span>
              <span className="c7">
                &nbsp;S&ouml;zle&#351;menin feshi i&ccedil;in
                belirtilen 45 g&uuml;nl&uuml;k &#304;hbar s&uuml;resi i&ccedil;erisinde sat&#305;c&#305;, verilen
                sipari&#351;lerden al&#305;c&#305;lara KUMPARA kazand&#305;ramayacak olup KUMPARA da&#287;&#305;tan
                i&#351;letmeler listesinde bulunamayaca&#287;&#305;n&#305; kabul etmektedir. Sat&#305;c&#305; bu s&uuml;re
                zarf&#305;nda al&#305;c&#305;lara fesih s&uuml;resi &ouml;ncesinde da&#287;&#305;tm&#305;&#351; oldu&#287;u
                KUMPARAlar&#305;n ge&ccedil;erlilik s&uuml;resinin sonuna kadar platformda kalmak, panelini a&ccedil;&#305;k
                tutmak ve KUMPARA ile gelen sipari&#351;leri kabul edip teslim etmek vas&#305;tas&#305;yla
                al&#305;c&#305;lara kulland&#305;rmak zorundad&#305;r.
              </span>
            </p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4">
              <span className="c6 c12">10.2.7.</span>
              <span className="c6">
                &nbsp;S&ouml;zle&#351;menin 10.2.6. maddesine
                ayk&#305;r&#305;l&#305;k halinde

              </span>
              <span className="c7">KOLAYYOLLA</span>
              <span className="c6">
                &rsquo;n&#305;n
                do&#287;mu&#351; ya da do&#287;acak her t&uuml;rl&uuml; nam ve ad alt&#305;ndaki zarar&#305;n&#305;
                sat&#305;c&#305;dan tazmin etme hakk&#305; bulunmakta olup bu hususun yan&#305; s&#305;ra
                sat&#305;c&#305;n&#305;n ilgili maddeye ayk&#305;r&#305;l&#305;k te&#351;kil eden her t&uuml;rl&uuml; eylemi
                neticesinde

              </span>
              <span className="c7">KOLAYYOLLA</span>
              <span className="c1">
                &rsquo;ya ihlal konusu KUMPARA
                miktar&#305; kadar cezai &#351;art&#305; nakden &ouml;deyece&#287;i de sat&#305;c&#305;n&#305;n
                kabul&uuml;ndedir.
              </span>
            </p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4">
              <span className="c6 c12">10.2.8.</span>
              <span className="c6">
                &nbsp;S&ouml;zle&#351;menin 10.2.7.maddesinde
                yaz&#305;l&#305; cezai &#351;art miktar&#305;n&#305;

              </span>
              <span className="c7">KOLAYYOLLA</span>
              <span
                className="c6"
              >
&nbsp;nakden tahsil yoluna gidebilece&#287;i gibi sat&#305;c&#305;n&#305;n
              </span>
              <span
                className="c7"
              >
                KOLAYYOLLA
              </span>
              <span className="c1">
                &nbsp;nezdindeki alacaklar&#305;ndan mahsup etme hakk&#305;na
                da sahiptir. Sat&#305;c&#305; bu husustaki t&uuml;m itiraz haklar&#305;ndan feragat etti&#287;ini kabul
                etmektedir.

              </span>
            </p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4">
              <span className="c6 c12">10.2.9.</span>
              <span className="c6">
                &nbsp;S&ouml;zle&#351;menin 10.2.7. maddesinde
                yaz&#305;l&#305; tazminat ve alacaklar&#305;n 10.2.8. maddede yaz&#305;l&#305; yollarla tahsilinin kabil
                olmamas&#305; halinde

              </span>
              <span className="c7">KOLAYYOLLA</span>
              <span className="c1">
                &rsquo;n&#305;n t&uuml;m
                yasal haklar&#305; sakl&#305; olup bu husus sat&#305;c&#305;n&#305;n ko&#351;ulsuz &#351;arts&#305;z
                kabul&uuml;ndedir.

              </span>
            </p>
            <p className="c3"><span className="c1 c11" /></p>
            <p className="c4"><span className="c5 c2">10.3. Kumparan&#305;n Kullan&#305;m&#305;</span></p>
            <p className="c3"><span className="c0" /></p>
            <p className="c4">
              <span className="c2">10.3.1.</span>
              <span className="c1">
                &nbsp;Al&#305;c&#305;n&#305;n kazanm&#305;&#351;
                oldu&#287;u KUMPARAlar yaln&#305;zca KUMPARAlar&#305;n kazan&#305;ld&#305;&#287;&#305; sat&#305;c&#305;larda
                45 g&uuml;n i&ccedil;erisinde kullan&#305;lacakt&#305;r.

              </span>
            </p>
            <p className="c3"><span className="c0" /></p>
            <p className="c4">
              <span className="c2">10.3.2.</span>
              <span className="c7">
                &nbsp;Al&#305;c&#305;n&#305;n HO&#350;GELD&#304;N
                S&#304;PAR&#304;&#350;&#304; ile kazanm&#305;&#351; oldu&#287;u KUMPARAlar, al&#305;c&#305;n&#305;n
                ayn&#305; sat&#305;c&#305;dan vermi&#351; oldu&#287;u devam eden asgari iki adet sipari&#351;inde
                maksimum
              </span>
              <span className="c7 c19">&nbsp;</span>
              <span className="c7">
                yar&#305; yar&#305;ya al&#305;c&#305;ya
                kulland&#305;r&#305;lacakt&#305;r.
              </span>
              <span className="c0">&nbsp;</span>
            </p>
            <p className="c3"><span className="c0" /></p>
            <p className="c4">
              <span className="c2">10.3.3.</span>
              <span className="c1">
                &nbsp;Al&#305;c&#305;n&#305;n kullanabilece&#287;i
                KUMPARA miktar&#305;, vermi&#351; oldu&#287;u sipari&#351;in toplam tutar&#305;n&#305;n maksimum
                %50&rsquo;si kadar olabilir.
              </span>
            </p>
            <p className="c3"><span className="c0" /></p>
            <p className="c4">
              <span className="c2">10.3.4.</span>
              <span className="c1">
                &nbsp;Sat&#305;c&#305;, platformda
                olu&#351;turdu&#287;u men&uuml;lerinin maksimum %10&rsquo;u kadarl&#305;k k&#305;sm&#305;nda KUMPARA ile
                &ouml;deme al&#305;nmas&#305;n&#305; istememe hakk&#305;na sahiptir. Sat&#305;c&#305; taraf&#305;ndan,
                KUMPARA ile &ouml;denemeyece&#287;i belirtilen &uuml;r&uuml;nlerin bulundu&#287;u sepetlerde KUMPARA
                kullan&#305;m&#305; yap&#305;lamayacakt&#305;r.

              </span>
            </p>
            <p className="c3"><span className="c1 c11" /></p>
            <p className="c4"><span className="c5 c2">MADDE 11 &ndash; &Ouml;DEME VE KOM&#304;SYON</span></p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4">
              <span className="c2">11.1.</span>
              <span className="c1">
                &nbsp;Sat&#305;c&#305; al&#305;c&#305;ya KOLAYYOLLA.app
                &uuml;zerinden ONL&#304;NE KRED&#304; KARTI ve ONL&#304;NE BANKA KARTI ile &ouml;deme imkan&#305;
                tan&#305;yaca&#287;&#305;n&#305; pe&#351;inen kabul, beyan ve taahh&uuml;t eder.
              </span>
            </p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4">
              <span className="c2">11.2</span>
              <span className="c1">
                . KOLAYYOLLA, al&#305;c&#305;n&#305;n KOLAYYOLLA Sistemi
                &uuml;zerinden ONL&#304;NE KRED&#304; KARTI ve ONL&#304;NE BANKA KARTI ile &ouml;deme yapt&#305;&#287;&#305;
                durumlarda, uygun d&uuml;&#351;t&uuml;&#287;&uuml; &ouml;l&ccedil;&uuml;de a&#351;a&#287;&#305;daki
                miktarlar d&uuml;&#351;&uuml;ld&uuml;kten sonra kalan Net Sipari&#351; Bedeli&rsquo;ni &Uuml;ye
                &#304;&#351;yeri&rsquo;ne 11.4 maddesinde a&ccedil;&#305;kland&#305;&#287;&#305; gibi
                aktaracakt&#305;r:
              </span>
            </p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4"><span className="c1">a) Komisyon;</span></p>
            <p className="c4"><span className="c1">b) Vergiler;</span></p>
            <p className="c4">
              <span className="c1">
                c) KOLAYYOLLA&rsquo;n&#305;n alacakl&#305;s&#305; oldu&#287;u di&#287;er her
                t&uuml;rl&uuml; alacak.
              </span>
            </p>
            <p className="c3"><span className="c1 c9" /></p>
            <p className="c4">
              <span className="c2">11.3.</span>
              <span className="c1">
                &nbsp;Al&#305;c&#305;n&#305;n ONL&#304;NE KRED&#304;
                KARTI ve ONL&#304;NE BANKA KARTI ile Elektronik &Ouml;deme Mekanizmalar&#305; vas&#305;tas&#305;yla
                &ouml;demeyi yapt&#305;&#287;&#305; durumlarda sipari&#351; bedelinin sat&#305;c&#305; ad&#305;na ve
                hesab&#305;na teslim al&#305;nmas&#305; hususunda sat&#305;c&#305;, KOLAYYOLLA&rsquo;&#305; ticari
                temsilcisi olarak atamaktad&#305;r. Sipari&#351; bedeli &ouml;demesinin sat&#305;c&#305;n&#305;n ticari
                temsilcisi olarak hareket eden KOLAYYOLLA&rsquo;a yap&#305;lmas&#305;yla birlikte sat&#305;&#351;
                s&ouml;zle&#351;mesi kapsam&#305;nda al&#305;c&#305;n&#305;n sipari&#351; i&ccedil;in &uuml;cret &ouml;deme
                borcu ifa edilmi&#351; olacakt&#305;r. An&#305;lan temsil yetkisinin sat&#305;c&#305; taraf&#305;ndan iptal
                edilmesi halinde KOLAYYOLLA, i&#351;bu S&ouml;zle&#351;me&rsquo;yi derhal feshetme ve
                sat&#305;c&#305;n&#305;n KOLAYYOLLA Sistemi &uuml;yeli&#287;ini iptal etme hakk&#305;na sahiptir.

              </span>
            </p>
            <p className="c3"><span className="c1 c9" /></p>
            <p className="c4">
              <span className="c2">11.4.</span>
              <span className="c1">
                &nbsp;Yukar&#305;da bahsedilen tutarlar&#305;n
                kesilmesinden sonra sat&#305;c&#305;n&#305;n KOLAYYOLLA nezdinde kalan bakiyesi hakkedi&#351; tarihine
                g&ouml;re ayn&#305; ay&#305;n 1. ve/veya 16. G&uuml;n&uuml; KOLAYYOLLA taraf&#305;ndan sat&#305;c&#305;
                hesab&#305;na aktar&#305;l&#305;r (&quot;&Ouml;deme G&uuml;n&uuml;&quot;). &Ouml;deme G&uuml;n&uuml; bir
                banka tatil g&uuml;n&uuml;ne rastlarsa izleyen i&#351; g&uuml;n&uuml;ne sarkar.
              </span>
            </p>
            <p className="c3"><span className="c1 c9" /></p>
            <p className="c4">
              <span className="c2">11.5.</span>
              <span className="c1">
                &nbsp;KOLAYOLLA, ge&ccedil;erli Sipari&#351;lerle ilgili
                sat&#305;c&#305; taraf&#305;ndan KOLAYOLLA&rsquo;ya &ouml;denmesi gereken Komisyon, iade masraflar&#305; ve
                di&#287;er tutarlar ve &ouml;demeler i&ccedil;in &ouml;nceki ay&#305;n son g&uuml;n&uuml;nden itibaren 7
                (yedi) g&uuml;nl&uuml;k s&uuml;re i&ccedil;erisinde sat&#305;c&#305;ya ayl&#305;k bir fatura verece&#287;ini
                kabul ve taahh&uuml;t eder. Faturalar sat&#305;c&#305;n&#305;n sistemde kay&#305;tl&#305; e-posta adresine
                e-posta ile g&ouml;nderilir.

              </span>
            </p>
            <p className="c3"><span className="c1 c9" /></p>
            <p className="c4">
              <span className="c2">11.6.</span>
              <span className="c1">
                &nbsp;Sat&#305;c&#305;, Sistem dahilinde KOLAYOLLA
                taraf&#305;ndan kendisine sa&#287;lanan hizmetlerin kar&#351;&#305;l&#305;&#287;&#305;nda kendisine iletilen
                ve ilgili al&#305;c&#305;ya ula&#351;t&#305;r&#305;lan sipari&#351;lerin T&uuml;rk Liras&#305;
                &uuml;zerinden tahakkuk edecek ve i&#351;yeri &uuml;yelik formunda taraflarca
                kararla&#351;t&#305;r&#305;lm&#305;&#351; olan hizmet bedelini KOLAYYOLLA&rsquo;ya &ouml;demeyi kabul ve
                taahh&uuml;t eder.
              </span>
            </p>
            <p className="c3"><span className="c5 c2" /></p>
            <p className="c4">
              <span className="c5 c2">
                MADDE 12: TANITIM VE SATI&#350; GEL&#304;&#350;T&#304;RME FAAL&#304;YETLER&#304;
                VE UYGULAMANIN DENETLENMES&#304;
              </span>
            </p>
            <p className="c4"><span className="c1">&nbsp;</span></p>
            <p className="c4">
              <span className="c2">12.1.</span>
              <span className="c1">
                &nbsp;Taraflar birbirlerinin tan&#305;t&#305;m&#305;,
                reklamlar&#305; ve sat&#305;&#351; geli&#351;tirme faaliyetleri i&ccedil;in gerekti&#287;i &#351;ekilde
                &ccedil;aba g&ouml;sterecek ve yapacaklar&#305; bilgilendirme ve uyar&#305;lara dikkat ederek uygun
                davranacakt&#305;r. Taraflar birbirlerinin talebi do&#287;rultusunda, &uuml;r&uuml;nlerin ve
                ara&ccedil;lar&#305;n&#305;n &uuml;st&uuml;ne tan&#305;t&#305;m i&#351;aretlerini koymay&#305;,
                de&#287;i&#351;tirmeyi ve kald&#305;rmay&#305; kabul eder.
              </span>
            </p>
            <p className="c4"><span className="c1">&nbsp;</span></p>
            <p className="c4">
              <span className="c2">12.2. </span>
              <span className="c1">
                Sat&#305;c&#305;, KOLAYYOLLA&rsquo;n&#305;n
                yaz&#305;l&#305; iznini almaks&#305;z&#305;n KOLAYYOLLA&rsquo;n&#305;n unvan&#305;n&#305;, i&#351;letme
                ad&#305;n&#305;, Marka, logo ve sair tan&#305;t&#305;m i&#351;aretlerini i&ccedil;eren po&#351;et,
                ka&#287;&#305;t ve sair ambalaj malzemesi bast&#305;ramaz ve kullanamaz.

              </span>
            </p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4">
              <span className="c2">12.3.</span>
              <span className="c1">
                &nbsp;Sat&#305;c&#305;n&#305;n Tan&#305;t&#305;m
                faaliyetlerine ili&#351;kin t&uuml;m d&ouml;k&uuml;manlar KOLAYYOLLA taraf&#305;ndan s&ouml;zle&#351;menin
                devam etti&#287;i s&uuml;rece &uuml;cretsiz temin edilecektir. S&ouml;zle&#351;menin sat&#305;c&#305;
                taraf&#305;ndan haks&#305;z bir &#351;ekilde feshi halinde KOLAYYOLLA tan&#305;t&#305;ma ve reklama dair
                yapm&#305;&#351; oldu&#287;u t&uuml;m masraf ve giderleri yasal faizi ile birlikte sat&#305;c&#305;dan
                isteme hakk&#305;na sahiptir.

              </span>
            </p>
            <p className="c3"><span className="c5 c2" /></p>
            <p className="c4"><span className="c5 c2">MADDE 13: TEM&#304;NAT</span></p>
            <p className="c3"><span className="c5 c2" /></p>
            <p className="c4">
              <span className="c2">13.1.</span>
              <span className="c1">
                &nbsp;SATICI bu S&ouml;zle&#351;me&lsquo;de
                yaz&#305;l&#305; her t&uuml;rl&uuml; beyan, taahh&uuml;t, edim ve Y&uuml;k&uuml;ml&uuml;l&uuml;klerinin ve
                bu S&ouml;zle&#351;me &lsquo;den do&#287;mu&#351;, do&#287;acak her t&uuml;rl&uuml;
                bor&ccedil;lar&#305;n&#305;n teminat&#305;n&#305; te&#351;kil etmek &uuml;zere T&uuml;rkiye&#39;de mukim
                muteber bir banka taraf&#305;ndan tanzim edilecek kay&#305;ts&#305;z ve &#351;arts&#305;z, kati ve
                s&uuml;resiz bir banka teminat mektubunu KOLAYYOLLA&rsquo;ya tevdi edecektir. Banka teminat mektubunun
                masraflar&#305; sat&#305;c&#305;ya &nbsp;aittir. KOLAYYOLLA, bu S&ouml;zle&#351;me&#39;nin
                y&uuml;r&uuml;rl&uuml;&#287;&uuml; s&uuml;resince her zaman teminat&#305;n t&uuml;r&uuml;n&uuml; ve/veya
                tutar&#305;n&#305; de&#287;i&#351;tirmek/artt&#305;rmak, sat&#305;c&#305;dan ilave veya yeni teminatlar
                istemek hakk&#305;n&#305; haizdir. Sat&#305;c&#305;, KOLAYYOLLA&rsquo;n&#305;n teminata ili&#351;kin
                taleplerini derhal yerine getirerek istenen ilave/yeni teminatlar&#305; KOLAYYOLLA&rsquo;ya tevdi etmeyi
                &#351;imdiden kabul etmi&#351;tir.

              </span>
            </p>
            <p className="c4"><span className="c1">&nbsp;</span></p>
            <p className="c4">
              <span className="c2">13.2. </span>
              <span className="c1">
                Sat&#305;c&#305; taraf&#305;ndan bu S&ouml;zle&#351;me
                uyar&#305;nca KOLAYYOLLA&rsquo;ya tevdi edilen teminatlar, sat&#305;c&#305;n&#305;n S&ouml;zle&#351;me ve
                mevzuat gere&#287;ince KOLAYYOLLA&rsquo;ya kar&#351;&#305; olan her t&uuml;rl&uuml; edim, taahh&uuml;t ve
                bor&ccedil;lar&#305;n&#305;n tamam&#305;n&#305; tam-zaman&#305;nda ifa etmi&#351; olmas&#305; kayd&#305;yla
                S&ouml;zle&#351;me&#39;nin sona ermesinden &uuml;&ccedil; ay sonra iade edilir.
              </span>
            </p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4"><span className="c5 c2">MADDE 14: F&#304;KR&#304; M&Uuml;LK&#304;YET HAKLARI</span></p>
            <p className="c4"><span className="c5 c2">&nbsp;</span></p>
            <p className="c4">
              <span className="c2">14.1. </span>
              <span className="c1">
                Sat&#305;c&#305;, sahibi oldu&#287;u logolar,
                foto&#287;raflar, sair tan&#305;t&#305;m i&#351;aretlerinin vs. KOLAYYOLLA taraf&#305;ndan platformla
                s&#305;n&#305;rl&#305; kalmak &uuml;zere kullan&#305;m&#305;na muvafakat etmektedir. Bu muvafakatin
                sat&#305;c&#305; taraf&#305;ndan verilmesi logo, foto&#287;raf, &uuml;r&uuml;n
                a&ccedil;&#305;klamalar&#305;, &uuml;r&uuml;n isimleri vb hususlar&#305;n platformda yer
                alaca&#287;&#305;n&#305;n garantisi anlam&#305;na gelmemekte olup tamam&#305; KOLAYYOLLA&rsquo;n&#305;n
                onay&#305;na tabidir.

              </span>
            </p>
            <p className="c4"><span className="c5 c2">&nbsp;</span></p>
            <p className="c4">
              <span className="c2">14.2.</span>
              <span className="c1">
                &nbsp;Sat&#305;c&#305;, KOLAYYOLLA&rsquo;n&#305;n
                yaz&#305;l&#305; iznini almaks&#305;z&#305;n KOLAYYOLLA markas&#305;n&#305; ve sair tan&#305;t&#305;m
                i&#351;aretlerini hi&ccedil;bir &#351;ekilde kullanamaz. Sat&#305;c&#305; KOLAYYOLLA&rsquo;n&#305;n Marka ve
                sair tan&#305;t&#305;m i&#351;aretlerini, &uuml;&ccedil;&uuml;nc&uuml; ki&#351;ilere kulland&#305;ramaz,
                taklit edemez, ayn&#305; veya benzerlerini &uuml;retemez/&uuml;rettiremez.

              </span>
            </p>
            <p className="c4"><span className="c5 c2">&nbsp;</span></p>
            <p className="c4">
              <span className="c2">14.3.</span>
              <span className="c1">
                &nbsp;Taraflar Markalar&#305;n &#351;&ouml;hretini ve
                birbirlerinin ticari itibar&#305;n&#305; koruyup g&uuml;&ccedil;lendirecek tarzda hareket etmek ve
                birbirlerinin Markalar&#305;na ve ticari itibar&#305;na zarar vermesi muhtemel davran&#305;&#351;lardan ve
                ticari ahlaka uygun olmayan faaliyetlerden ka&ccedil;&#305;nmakla y&uuml;k&uuml;ml&uuml;d&uuml;r.
              </span>
            </p>
            <p className="c4"><span className="c1">&nbsp;</span></p>
            <p className="c4">
              <span className="c2">14.4.</span>
              <span className="c1">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Taraflar
                &uuml;&ccedil;&uuml;nc&uuml; ki&#351;ilerin &Uuml;r&uuml;n&#39;&uuml; ve/veya Markalar&#305; ya da
                birbirlerinin di&#287;er marka ve sair tan&#305;t&#305;m i&#351;aretlerini taklit ettiklerini veya
                di&#287;er bir surette tecav&uuml;zde bulunduklar&#305;n&#305; ya da haks&#305;z olarak
                kulland&#305;klar&#305;n&#305; &ouml;&#287;rendi&#287;i takdirde, durumu derhal birbirlerine bildirmek ve bu
                konuda verilecek talimata g&ouml;re hareket etmek ve markaya tecav&uuml;z&uuml;n/haks&#305;z rekabetin
                &ouml;nlenmesi i&ccedil;in gerekli her t&uuml;rl&uuml; i&#351;birli&#287;i-yard&#305;m&#305; yapmakla
                y&uuml;k&uuml;ml&uuml;d&uuml;r.
              </span>
            </p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4">
              <span className="c2">14.5.</span>
              <span className="c1">
                &nbsp;Taraflar masraflar&#305; kendilerine ait olmak
                &uuml;zere ve kendi karar&#305;yla ve sadece kendi kontrol&uuml; alt&#305;nda olmak &uuml;zere, ya kendi
                ad&#305;na ya da sat&#305;c&#305; ad&#305;na veya (m&uuml;mk&uuml;n oldu&#287;u takdirde) her ikisinin
                ad&#305;na, KOLAYYOLLA&rsquo;n&#305;n Fikri M&uuml;lkiyetinin ihlalini veya sair haks&#305;z rekabet
                fiillerini &ouml;nlemek i&ccedil;in gerekli g&ouml;rd&uuml;&#287;&uuml; tedbirleri alabilir.
              </span>
            </p>
            <p className="c3"><span className="c5 c2" /></p>
            <p className="c4"><span className="c5 c2">MADDE 15 &ndash; G&#304;ZL&#304;L&#304;K ve KVKK</span></p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4">
              <span className="c2">15.1.</span>
              <span className="c1">
                &nbsp;Gizli bilgi; taraf&#305;nca gizli oldu&#287;u
                bildirilen her t&uuml;rl&uuml; bilgi, taraflar&#305;n i&#351;tigal etti&#287;i her t&uuml;rl&uuml; i&#351;
                (bunlar&#305;n ke&#351;fi, icad&#305;, ara&#351;t&#305;r&#305;lmas&#305;, geli&#351;tirilmesi, imali ve
                sat&#305;&#351; dahil), proses veya genel ticari faaliyetler ile pazarlama (komisyon oranlar&#305;,
                sat&#305;&#351; maliyetleri, k&acirc;r, fiyatland&#305;rma metotlar&#305;, organizasyon ve personel listesi
                dahil) ile ilgili her t&uuml;rl&uuml; bilgiyi kapsamaktad&#305;r.
              </span>
            </p>
            <p className="c3"><span className="c5 c2" /></p>
            <p className="c4">
              <span className="c2">15.2.</span>
              <span className="c7">
                &nbsp;Taraflar i&#351;bu s&ouml;zle&#351;me
                kapsam&#305;nda, kendi aralar&#305;nda yaz&#305;l&#305;, s&ouml;zl&uuml;, manyetik ortamda veya ba&#351;ka
                bir &#351;ekilde aktar&#305;lan fikir, bilgi, i&ccedil;erik, veri, belgeler ve gizli bilgi hakk&#305;nda
                gizlilik esaslar&#305;na uygun hareket edecek, bu bilgileri s&ouml;zle&#351;menin amac&#305;
                d&#305;&#351;&#305;nda hi&ccedil;bir &#351;ekilde kullanmayacak, da&#287;&#305;tmayacak, hi&ccedil;bir
                &#351;ekilde &uuml;&ccedil;&uuml;nc&uuml; ki&#351;ilere aktarmayacak, hen&uuml;z kamuya
                duyurulmam&#305;&#351; &uuml;r&uuml;n ve hizmetlere, faaliyetlere ili&#351;kin her t&uuml;rl&uuml; belge ve
                bilginin gizli tutulmas&#305;n&#305; sa&#287;layacak ve bu bilgilerin yetkisiz ki&#351;ilerce
                kullan&#305;lmas&#305;n&#305; &ouml;nlemek &uuml;zere gerekli olan her t&uuml;rl&uuml; g&uuml;venlik
                &ouml;nlemlerini alacakt&#305;r.
              </span>
            </p>
            <p className="c3"><span className="c5 c2" /></p>
            <p className="c4">
              <span className="c2">15.3.</span>
              <span className="c1">
                &nbsp;Hali haz&#305;rda kamunun bilgisine sunulmu&#351;
                olan veya y&uuml;r&uuml;rl&uuml;kteki t&uuml;m mevzuat gere&#287;i ve/veya herhangi bir devlet otoritesinin
                iste&#287;i &uuml;zerine a&ccedil;&#305;klanmas&#305; istenmi&#351; olan veya gizlilik
                y&uuml;k&uuml;ml&uuml;l&uuml;&#287;&uuml; kapsam&#305;ndan &ouml;nce veya bu kapsam i&ccedil;erisinde
                olmayan bir ba&#351;ka &uuml;&ccedil;&uuml;nc&uuml; &#351;ah&#305;s taraf&#305;ndan ba&#287;&#305;ms&#305;z
                olarak elde edilmi&#351; olan bilgiler, gizli bilgi kapsam&#305; d&#305;&#351;&#305;nda olup bu maddeye
                istisna te&#351;kil ederler.
              </span>
            </p>
            <p className="c3"><span className="c5 c2" /></p>
            <p className="c4">
              <span className="c2">15.4</span>
              <span className="c1">
                . Taraflar i&#351; bu s&ouml;zle&#351;menin ve
                s&ouml;zle&#351;me kapsam&#305; i&#351; ve i&#351;lemler s&#305;ras&#305;nda toplanan bilgi ve belgelerin
                gizli bilgi niteli&#287;inde oldu&#287;unu kabul ve taahh&uuml;t eder. Taraflar, di&#287;er taraf&#305;n
                yaz&#305;l&#305; onay&#305; olmaks&#305;z&#305;n, bu bilgileri &uuml;&ccedil;&uuml;nc&uuml;
                &#351;ah&#305;slarla kesinlikle payla&#351;mamay&#305;, faaliyet d&#305;&#351;&#305; hi&ccedil;bir nedenle
                ticari ama&ccedil;la kullanmamay&#305; veya satmamay&#305; kabul ve taahh&uuml;t eder.
              </span>
            </p>
            <p className="c3"><span className="c5 c2" /></p>
            <p className="c4">
              <span className="c2">15.5.</span>
              <span className="c1">
                &nbsp;Taraflar, kendi
                &ccedil;al&#305;&#351;anlar&#305;n&#305;n veya kendileri ad&#305;na i&#351; yapanlar&#305;n i&#351;bu
                s&ouml;zle&#351;mede &ouml;ng&ouml;r&uuml;len gizlili&#287;e ayk&#305;r&#305;
                davran&#305;&#351;lar&#305;ndan dolay&#305; m&uuml;&#351;tereken ve m&uuml;teselsilen sorumlu olup,
                &ccedil;al&#305;&#351;anlar&#305;n&#305;n veya kendileri ad&#305;na i&#351; yapanlar&#305;n gizlilik
                ilkelerine riayet edece&#287;ini kabul ve taahh&uuml;t eder. Taraflar, kendisi ad&#305;na i&#351;
                yapanlar&#305;n gizlili&#287;e ayk&#305;r&#305; tutum ve davran&#305;&#351;lar&#305; halinde birbirlerine
                kar&#351;&#305; bizzat sorumludur.
              </span>
            </p>
            <p className="c3"><span className="c5 c2" /></p>
            <p className="c4">
              <span className="c2">15.6.</span>
              <span className="c1">
                &nbsp;Taraflar, birbirlerine temin etmi&#351;
                olduklar&#305; sat&#305;&#351; ile ilgili belge ve bilginin, birbirlerinin r&#305;zas&#305; haricinde
                s&ouml;zle&#351;meye ayk&#305;r&#305; olarak if&#351;a edildi&#287;inin &ouml;&#287;renilmesi halinde
                if&#351;a eden taraf&#305;n bundan dolay&#305; sorumlu oldu&#287;unu kabul eder. Taraflar, bu bilgi ve
                belgelerin 3. &#351;ah&#305;slara iletilmemesi i&ccedil;in gerekli her t&uuml;rl&uuml; tedbiri almay&#305;
                taahh&uuml;t etti&#287;i gibi, her t&uuml;rl&uuml; tedbiri almas&#305;na ra&#287;men, bu bilgi ve belgelerin
                yay&#305;lmas&#305;na m&acirc;ni olamad&#305;&#287;&#305;n&#305; ve/veya kusuru
                olmad&#305;&#287;&#305;n&#305; ileri s&uuml;rerek sorumluluktan kurtulamaz.
              </span>
            </p>
            <p className="c3"><span className="c5 c2" /></p>
            <p className="c4">
              <span className="c2">15.7.</span>
              <span className="c1">
                &nbsp;&#304;&#351; bu s&ouml;zle&#351;meye
                ayk&#305;r&#305; bir durumun g&uuml;ndeme gelmesi ile taraflar, birbirlerinin maruz kalaca&#287;&#305; her
                t&uuml;rl&uuml; zarar, dava, talep, masraf ya da kovu&#351;turma vb. kar&#351;&#305;s&#305;nda
                m&uuml;nhas&#305;ran sorumlu olup, kendilerine g&ouml;nderilen ilk yaz&#305;l&#305; ihtar akabinde tam ve
                eksiksiz olarak nakden ve defaten, pe&#351;in olarak tazmin edecektir. Herhangi bir gizli bilgi&rsquo;nin
                izinsiz veya yasad&#305;&#351;&#305; olarak i&#351;lenmesine ve bunlara eri&#351;ilmesi, kayb&#305;, yok
                olmas&#305; veya zarar g&ouml;rmesi ya da kullan&#305;lamaz hale gelmesi halinde, Taraflar derhal di&#287;er
                di&#287;er taraf&#305; bilgilendirecek ve her t&uuml;rl&uuml; masraf ve gideri kendisine ait olarak ilgili
                gizli bilgi&rsquo;yi eski hale getirmek &uuml;zere gerekli iyile&#351;tirici &ouml;nlemleri derhal
                alacakt&#305;r. Taraflar, kanunda &ouml;nceden belirtilen ola&#287;an haller ve yasal zorunluluklar
                d&#305;&#351;&#305;nda yurtd&#305;&#351;&#305; devlet otoritesinden talep edilen bilgi ve belgeler
                i&ccedil;in 3 g&uuml;n i&ccedil;inde di&#287;er tarafa yaz&#305;l&#305; bildirimde bulunacakt&#305;r.
                Taraflar, kar&#351;&#305; taraf&#305;n yaz&#305;l&#305; onay&#305; olmaks&#305;z&#305;n talep edilen
                hi&ccedil;bir bilgiyi 3. ki&#351;ilere, yurtd&#305;&#351;&#305; devlet otoritesine, kurum ya da
                kurulu&#351;lara aktaramaz, herhangi bir &#351;ekilde da&#287;&#305;tamaz, bas&#305;n yay&#305;n
                organlar&#305; ve medya kurulu&#351;lar&#305; vas&#305;tas&#305;yla a&ccedil;&#305;klayamaz, reklam
                amac&#305;yla kullanamaz.&rdquo;
              </span>
            </p>
            <p className="c3"><span className="c6 c12 c16" /></p>
            <p className="c4">
              <span className="c2">15.8.</span>
              <span className="c1">
                &nbsp;Taraflar, i&#351; bu s&ouml;zle&#351;menin imza
                tarihinden sonra; birbirlerine &ccedil;&ouml;z&uuml;m orta&#287;&#305;, yat&#305;r&#305;mc&#305; ve veya
                partner vs. gibi s&#305;fatlarla i&#351; bu s&ouml;zle&#351;mede tan&#305;mlanan faaliyetleri
                ger&ccedil;ekle&#351;tirmek amac&#305;yla tan&#305;&#351;t&#305;rd&#305;klar&#305; networkleriyle; i&#351;
                bu s&ouml;zle&#351;medeki taraflardan biri &ouml;tekini asla ekarte ederek (bypass yaparak) temasta
                bulunmayacakt&#305;r; t&uuml;m temaslar &ouml;teki tarafa beyan edilecek ve e-posta
                yaz&#305;&#351;malar&#305; olmas&#305; halinde taraflar birbirlerini s&ouml;z konusu ki&#351;ilerle
                yaz&#305;&#351;&#305;rken &ldquo;cc&rdquo; yapacak; &nbsp;tan&#305;&#351;t&#305;r&#305;lan bu ki&#351;i
                (networklerle) ile di&#287;er taraf&#305;n yaz&#305;l&#305; onay&#305; olmaks&#305;z&#305;n her hangi bir
                ticari faaliyette bulunmayacakt&#305;r. Aksi halde, b&ouml;ylesi bir eylemin olmas&#305; halinde, i&#351; bu
                eylemin neticesinde elde edilen ticari menfaatler (bu s&ouml;zle&#351;mede ekarte eden taraf&#305;n elde
                etti&#287;i &#351;ahsi menfaatler toplam&#305;) ekarte edilen tarafa &ouml;denecektir. B&ouml;ylesi bir
                ticari faaliyetin ortaya &ccedil;&#305;kmas&#305; halinde, ekarte edilen taraf&#305;n tazminat hakk&#305;
                sakl&#305;d&#305;r. &nbsp;
              </span>
            </p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4">
              <span className="c2">15.9.</span>
              <span className="c1">
                &nbsp;Taraflar, gizli oldu&#287;u bildirilmi&#351; olsun
                veya olmas&#305;n, i&#351;bu S&ouml;zle&#351;me&rsquo;nin m&uuml;zakere edilmesi ve ifa edilmesi sonucu elde
                etmi&#351; olabilece&#287;i hi&ccedil;bir bilgiyi herhangi bir &uuml;&ccedil;&uuml;nc&uuml; &#351;ahsa
                kanunen a&ccedil;&#305;k&ccedil;a yetkili k&#305;l&#305;nan ki&#351;iler hari&ccedil; di&#287;er
                taraf&#305;n yaz&#305;l&#305; iznini almadan a&ccedil;&#305;klamamay&#305;, if&#351;a etmemeyi; istihdam
                etti&#287;i t&uuml;m &#351;ah&#305;slar&#305;n veya di&#287;er taraf ile ili&#351;kisi sonucu bilgileri
                alm&#305;&#351; olan &#351;ah&#305;slar&#305;n bu y&uuml;k&uuml;ml&uuml;l&uuml;&#287;&uuml; yerine
                getireceklerini, aksi halde onlar&#305;n davran&#305;&#351;lar&#305;ndan bizzat ve do&#287;rudan sorumlu
                olacaklar&#305;n&#305; taahh&uuml;t etmi&#351;lerdir. Taraflar&#305;n gizlilik
                y&uuml;k&uuml;ml&uuml;l&uuml;&#287;&uuml;, i&#351;bu S&ouml;zle&#351;menin her ne sebeple olursa olsun
                feshinden veya sona ermesinden sonra da s&uuml;resiz olarak h&uuml;k&uuml;m ifade etmeye devam edecektir.
                Taraflar, kendisi/kendileri ile payla&#351;&#305;lan verilerin 6698 say&#305;l&#305; Ki&#351;isel Verilerin
                Korunmas&#305; Kanunu (&ldquo;KVKK&rdquo;) ve ki&#351;isel verilerin korunmas&#305;na ili&#351;kin
                uluslararas&#305; mevzuat kapsam&#305;nda birer ki&#351;isel veri oldu&#287;unu bilir ve ki&#351;isel
                verilerin korunmas&#305;n&#305;n sa&#287;lanmas&#305; i&ccedil;in azami &ouml;zeni g&ouml;sterir. Taraflar,
                i&#351;bu s&ouml;zle&#351;me konusu i&#351; ve i&#351;lemler i&ccedil;in kendisi ile payla&#351;&#305;lan
                ki&#351;isel verileri &uuml;&ccedil;&uuml;nc&uuml; ki&#351;iler ile payla&#351;mayaca&#287;&#305;n&#305;, bu
                verileri yaln&#305;zca i&#351;bu s&ouml;zle&#351;mede belirtilen ama&ccedil; ile s&#305;n&#305;rl&#305; bir
                bi&ccedil;imde kullanaca&#287;&#305;n&#305;, bu verileri kullan&#305;rken KVKK&rsquo; ya ve Veri Koruma
                mevzuat h&uuml;k&uuml;mlerine uygun davranaca&#287;&#305;n&#305; &nbsp;i&#351;bu s&ouml;zle&#351;menin sona
                ermesinden sonra i&#351;bu s&ouml;zle&#351;me gere&#287;i &uuml;stlenmi&#351; oldu&#287;u ki&#351;isel
                verilerin korunmas&#305;na ili&#351;kin y&uuml;k&uuml;ml&uuml;l&uuml;klerine s&uuml;resiz olarak devam
                edece&#287;ini ve mevzuatta bir zorunluluk olmamas&#305; halinde bu verileri i&#351;lemeyece&#287;ini ve
                silece&#287;ini, bunun d&#305;&#351;&#305;nda kendisinin ve/veya ekibinin yapaca&#287;&#305; her
                t&uuml;rl&uuml; i&#351;lemenin yetkisiz olaca&#287;&#305;n&#305; kabul ve taahh&uuml;t eder. Taraflar
                kendilerinin hukuka ayk&#305;r&#305; olarak i&#351;ledikleri ki&#351;isel veriler i&ccedil;in bizzat sorumlu
                olup bu i&#351;leme sebebi ile &uuml;&ccedil;&uuml;nc&uuml; ki&#351;inin u&#287;rayaca&#287;&#305; her
                t&uuml;rl&uuml; zarar&#305; derhal tazmin edece&#287;ini, bu hususta resmi mercilere ve 3. Ki&#351;ilere
                kar&#351;&#305; m&uuml;nhas&#305;ran sorumlu oldu&#287;unu kabul, beyan ve taahh&uuml;t ederler. Taraflar
                i&#351;bu s&ouml;zle&#351;me kapsam&#305;ndaki y&uuml;k&uuml;ml&uuml;l&uuml;klerine ayk&#305;r&#305;
                davranmalar&#305; nedeniyle di&#287;er taraf&#305;n 3 ki&#351;i, kurum/kurulu&#351;lara herhangi cezai
                &#351;art &ouml;denmesi veya di&#287;er taraf&#305;n aleyhine idari veya cezai yapt&#305;r&#305;m
                uygulanmas&#305; nedeniyle &ouml;deme yapmak durumunda kalmas&#305; halinde, i&#351;bu s&ouml;zle&#351;me
                y&uuml;k&uuml;ml&uuml;l&uuml;klerine ayk&#305;r&#305; davranan taraf i&#351;bu bedelleri di&#287;er taraftan
                g&ouml;nderilen ilk yaz&#305;l&#305; ihtar akabinde tam ve eksiksiz olarak nakden ve defaten, pe&#351;in
                olarak &ouml;deyecektir.
              </span>
            </p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4">
              <span className="c2">15.10.</span>
              <span className="c1">
                &nbsp;&#304;&#351;bu madde ile belirtilen
                y&uuml;k&uuml;ml&uuml;l&uuml;kler s&uuml;resiz olup, i&#351; bu s&ouml;zle&#351;me sona erse dahi devam
                edecektir. Taraflar birbirleri hakk&#305;nda &ouml;&#287;rendikleri her t&uuml;rl&uuml; gizli bilgiyi
                korumay&#305; kabul ve taahh&uuml;t eder. &#304;&#351;bu S&ouml;zle&#351;me&rsquo;nin sona ermesi
                &uuml;zerine taraflar, derhal, en ge&ccedil; 3 g&uuml;n, veya taraflarca belirlenecek (ve daha k&#305;sa
                olabilecek) bir s&uuml;re i&ccedil;erisinde i&#351;bu maddede tan&#305;mland&#305;&#287;&#305; &uuml;zere
                gizli bilgi te&#351;kil eden t&uuml;m veri, bilgi ve e&#351;yay&#305; kendisince &uuml;retilen veya
                ba&#351;ka bir &#351;ekilde hakimiyetinde bulunan t&uuml;m kopya, uyarlama ve derlemeleriyle birlikte
                di&#287;er tarafa iade etmeyi kabul, beyan ve taahh&uuml;t eder.
              </span>
            </p>
            <p className="c3"><span className="c5 c2" /></p>
            <p className="c4"><span className="c2">MADDE 16 &ndash; S&Ouml;ZLE&#350;MEY&#304; DEV&#304;R YASA&#286;I</span></p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4">
              <span className="c2">16.1.</span>
              <span className="c1">
                &nbsp;Taraflar birbirlerinin yaz&#305;l&#305; onay&#305;
                olmaks&#305;z&#305;n, s&ouml;zle&#351;meden do&#287;an herhangi bir
                y&uuml;k&uuml;ml&uuml;l&uuml;&#287;&uuml;n&uuml; ve/veya hak ve/veya alaca&#287;&#305;n&#305; ve/veya
                borcunu &uuml;&ccedil;&uuml;nc&uuml; ki&#351;ilere devir, temlik ya da ciro edemez. Taraflar, herhangi bir
                sebeple kar&#351;&#305; taraf&#305;n yaz&#305;l&#305; onay&#305; olmaks&#305;z&#305;n,
                &uuml;&ccedil;&uuml;nc&uuml; bir &#351;ahs&#305; i&#351;bu s&ouml;zle&#351;mede yaz&#305;l&#305; olan
                sorumluluklar&#305;na, hak ve alacaklar&#305;na ortak edemeyecektir. Aksi halde kar&#351;&#305; taraf
                u&#287;rayaca&#287;&#305; her t&uuml;rl&uuml; zarar ve ziyan&#305;n&#305; talep etme hakk&#305; sakl&#305;
                kalmak kayd&#305;yla ihtarname ke&#351;idesine gerek kalmaks&#305;z&#305;n ve herhangi bir hukuki karar
                almaya gerek olmaks&#305;z&#305;n s&ouml;zle&#351;meyi tek tarafl&#305; ve tazminats&#305;z olarak
                feshetmeye, hi&ccedil;bir gerek&ccedil;e g&ouml;stermeksizin do&#287;mu&#351; ya da do&#287;acak t&uuml;m
                alacaklar&#305;n&#305; tahsil etmeye yetkilidir.
              </span>
            </p>
            <p className="c3"><span className="c5 c2" /></p>
            <p className="c4">
              <span className="c2">16.2.</span>
              <span className="c1">
                &nbsp;Taraflarca b&ouml;yle bir yaz&#305;l&#305; iznin
                verilmi&#351; olmas&#305;, &uuml;&ccedil;&uuml;nc&uuml; ki&#351;ilerin yapm&#305;&#351; oldu&#287;u i&#351;
                ve i&#351;lemlerden &ouml;t&uuml;r&uuml; taraflar&#305;n s&ouml;zle&#351;meden kaynaklanan
                sorumluluklar&#305;n&#305;n kald&#305;r&#305;lm&#305;&#351; olmas&#305; anlam&#305;n&#305; hi&ccedil;bir
                &#351;ekilde ta&#351;&#305;maz. &nbsp;Taraflar&#305;n yetkilendirdi&#287;i ger&ccedil;ek ya da t&uuml;zel
                ki&#351;ilerin vermi&#351; oldu&#287;u zararlardan dolay&#305; olu&#351;acak hukuki ve cezai sorumluluktan
                taraflar mesul de&#287;ildir. Taraflar&#305;n yetkilendirdi&#287;i ger&ccedil;ek ya da t&uuml;zel
                ki&#351;ilerin i&#351; bu s&ouml;zle&#351;me maddelerinden herhangi birisini ihlal etmesi durumunda
                di&#287;er taraf s&ouml;zle&#351;meyi tek tarafl&#305; ve bildirimsiz feshetmeye ve do&#287;mu&#351; ya da
                do&#287;acak t&uuml;m alacaklar&#305;n&#305; tahsile amirdir.
              </span>
            </p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4"><span className="c5 c2">MADDE 17 &ndash; M&Uuml;CB&#304;R SEBEP</span></p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4">
              <span className="c2">17.1.</span>
              <span className="c1">
                &nbsp;M&uuml;cbir sebepler; &ouml;nceden tahmin
                edilemeyen, kar&#351;&#305; konulamayan olaylard&#305;r. Bu durumlar, s&ouml;zle&#351;menin gerekli
                &#351;ekilde yerine getirilmesini engelleyen ya da ortadan kald&#305;ran ve gereken &ccedil;aban&#305;n
                g&ouml;sterilmesine ra&#287;men taraflar&#305;n ger&ccedil;ekle&#351;mesine engel olunamayan,
                ka&ccedil;&#305;nmas&#305; imk&acirc;ns&#305;z olan grev, lokavt, harp veya sald&#305;r&#305;, sivil
                ayaklanma, bula&#351;&#305;c&#305; hastal&#305;k ve do&#287;al afetlerle bunlar&#305;n sonucunda
                olu&#351;abilecek karayolu, demiryolu ve limanlar ile di&#287;er ula&#351;&#305;m yollar&#305;n&#305;n
                kullan&#305;lmas&#305;ndaki imk&acirc;ns&#305;zl&#305;klar, &#304;thalat ve ihracat&#305;n ge&ccedil;ici ya
                da daimi olarak durdurulmas&#305; veya k&#305;s&#305;tlanmas&#305;, Uluslararas&#305; yapt&#305;r&#305;mlar,
                ulusal tedbir ve k&#305;s&#305;tlamalar vb. gibi hallerdir. M&uuml;cbir sebep hallerinin kabul edilebilmesi
                i&ccedil;in;
              </span>
            </p>
            <p className="c3"><span className="c5 c2" /></p>
            <p className="c4">
              <span className="c2">17.1.1.</span>
              <span className="c1">
                &nbsp;M&uuml;cbir sebebin s&ouml;zle&#351;menin
                uygulanmas&#305;na engel olmas&#305; veya s&ouml;zle&#351;menin gerekli &#351;ekilde yerine getirilmesini
                engellemesi,
              </span>
            </p>
            <p className="c4">
              <span className="c2">17.1.2. </span>
              <span className="c1">
                Taraflar&#305;n m&uuml;cbir sebebin vukuu ile ilgili
                olarak herhangi bir kusurunun veya kasti bir eylemin bulunmamas&#305;,
              </span>
            </p>
            <p className="c4">
              <span className="c2">17.1.3</span>
              <span className="c1">
                . Taraflar&#305;n m&uuml;cbir sebebi ortadan
                kald&#305;rmaya g&uuml;c&uuml;n&uuml;n yetmemesi gerekmektedir.
              </span>
            </p>
            <p className="c3"><span className="c5 c2" /></p>
            <p className="c4">
              <span className="c2">17.2.</span>
              <span className="c1">
                &nbsp;Taraflardan biri m&uuml;cbir sebep nedeniyle bu
                anla&#351;ma alt&#305;ndaki y&uuml;k&uuml;ml&uuml;l&uuml;klerini k&#305;smen veya tamamen yerine
                getiremezse; etkilenen taraf b&uuml;t&uuml;n h&#305;z&#305;yla makul gayreti g&ouml;stererek m&uuml;cbir
                sebepten do&#287;an durumu ortadan kald&#305;rmaya &ccedil;al&#305;&#351;acakt&#305;r. M&uuml;cbir sebep
                olmas&#305; durumunda m&uuml;cbir sebepten etkilenen taraf m&uuml;cbir sebebin meydana gelmesinden itibaren
                2 (iki) g&uuml;n i&ccedil;erisinde kar&#351;&#305; tarafa m&uuml;cbir sebebin ne oldu&#287;undan haberdar
                edecek ve 1(bir) hafta i&ccedil;erisinde m&uuml;cbir sebebin tahmini ortadan kalkma s&uuml;resini ve
                sebebini yaz&#305;l&#305; olarak KOLAYYOLLA&rsquo;ya bildirecektir. Taraflar m&uuml;cbir sebebin ne
                oldu&#287;unu, olu&#351; tarihini ve s&uuml;resini resmi kurum ve kurulu&#351;lardan al&#305;nm&#305;&#351;
                yaz&#305; ile 7 (yedi) i&#351; g&uuml;n&uuml; i&ccedil;inde belgeleyecektir. M&uuml;cbir sebebin 60
                (altm&#305;&#351;) g&uuml;nden fazla s&uuml;rmesi durumunda, taraflar durum tespiti yaparak, bundan sonraki
                uygulamalar&#305;n&#305;n nas&#305;l olaca&#287;&#305;na birlikte karar vereceklerdir.

              </span>
            </p>
            <p className="c3"><span className="c5 c2" /></p>
            <p className="c4"><span className="c2">MADDE 19 &ndash;VERG&#304; VE D&#304;&#286;ER G&#304;DERLER</span></p>
            <p className="c3"><span className="c5 c2" /></p>
            <p className="c4">
              <span className="c1">
                &#304;&#351;bu s&ouml;zle&#351;meden ve ekinden/eklerinden kaynakl&#305;
                do&#287;mu&#351; ve do&#287;acak damga vergisi, har&ccedil;, fon vs. mali
                y&uuml;k&uuml;ml&uuml;l&uuml;klerden taraflar yar&#305; yar&#305;ya sorumlu olacak ve
                &ouml;deyecektir.
              </span>
            </p>
            <p className="c3"><span className="c5 c2" /></p>
            <p className="c4"><span className="c5 c2">MADDE 20 - &#304;HBAR</span></p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4">
              <span className="c1">
                &#304;&#351;bu s&ouml;zle&#351;me uyar&#305;nca yap&#305;lacak t&uuml;m ihbarlar
                yaz&#305;l&#305; olarak a&#351;a&#287;&#305;daki usullerden birine g&ouml;re yap&#305;lacakt&#305;r:
              </span>
            </p>
            <p className="c4">
              <span className="c1">
                a) Kurye veya iadeli taahh&uuml;tl&uuml; mektup ile taraflar&#305;n i&#351;bu
                s&ouml;zle&#351;mede yaz&#305;l&#305; adreslerine g&ouml;nderimi,
              </span>
            </p>
            <p className="c4">
              <span className="c1">
                b) Taraflar&#305;n bildirdikleri e-posta adreslerine g&ouml;nderilen ihbar
                yaz&#305;lar&#305;yla,
              </span>
            </p>
            <p className="c4">
              <span className="c1">
                c) Taraflar&#305;n i&#351;bu s&ouml;zle&#351;mede yaz&#305;l&#305; a&ccedil;&#305;k
                adreslerine noter kanal&#305;yla g&ouml;nderilecek olan ihtarnameler ile.
              </span>
            </p>
            <p className="c3"><span className="c5 c2" /></p>
            <p className="c4"><span className="c5 c2">MADDE 21&ndash; B&Ouml;L&Uuml;NEB&#304;L&#304;RL&#304;K</span></p>
            <p className="c3"><span className="c5 c2" /></p>
            <p className="c4">
              <span className="c2">21.1. </span>
              <span className="c7">
                Taraflar, S&ouml;zle&#351;me&rsquo;ye ili&#351;kin
                de&#287;i&#351;ikliklerin ancak yaz&#305;l&#305; &#351;ekilde yap&#305;labilece&#287;i hususunda
                mutab&#305;kt&#305;rlar.
              </span>
            </p>
            <p className="c3"><span className="c5 c2" /></p>
            <p className="c4">
              <span className="c2">21.2. </span>
              <span className="c1">
                Bu S&ouml;zle&#351;me&rsquo;nin h&uuml;k&uuml;mlerinden
                herhangi birisinin ge&ccedil;ersiz veya ifa edilemez olmas&#305;, S&ouml;zle&#351;me&rsquo;nin di&#287;er
                h&uuml;k&uuml;mlerinin ge&ccedil;erlili&#287;ini etkilemez. Ge&ccedil;ersiz veya ifa edilemez say&#305;lan
                h&uuml;k&uuml;m, S&ouml;zle&#351;meye hi&ccedil; konulmam&#305;&#351; say&#305;larak, Taraflarca
                ge&ccedil;ersiz ve ifa edilemez say&#305;lan h&uuml;kme m&uuml;mk&uuml;n oldu&#287;unca yak&#305;n
                &#351;artlarda ve s&ouml;z konusu h&uuml;km&uuml;n amac&#305;n&#305; en yak&#305;n &#351;ekilde
                kar&#351;&#305;layan ge&ccedil;erli bir h&uuml;k&uuml;mle de&#287;i&#351;tirilecektir. Ancak,
                ge&ccedil;ersiz say&#305;lan h&uuml;k&uuml;m, taraflar&#305;n i&#351;bu s&ouml;zle&#351;meyi yapma iradesini
                ve i&#351;lem temelinin &ccedil;&ouml;kmesini gerektirecek &#351;ekilde ortadan kald&#305;r&#305;r nitelikte
                ise, iradesi bu y&ouml;nde etkilenen taraf, s&ouml;zle&#351;meyi feshedebilir. Taraflardan herhangi birinin
                i&#351;bu S&ouml;zle&#351;meden do&#287;an haklar&#305;ndan birini kullanmamas&#305;, s&ouml;z konusu
                hakk&#305;n ve takip eden haklar&#305;n kayb&#305; anlam&#305;na gelmez ve bu konuda team&uuml;l
                olu&#351;turmaz.
              </span>
            </p>
            <p className="c3"><span className="c5 c2" /></p>
            <p className="c4"><span className="c5 c2">MADDE 22&ndash; YORUM</span></p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4">
              <span className="c2">22.1.</span>
              <span className="c1">
                &nbsp;&#304;&#351;bu S&ouml;zle&#351;me bir tek i&#351;
                ortakl&#305;&#287;&#305; s&ouml;zle&#351;mesi olup taraflar aras&#305;nda hangi ama&ccedil;la olursa olsun
                herhangi bir t&uuml;rden bir ortakl&#305;k veya ortak giri&#351;im ili&#351;kisi tesis veya te&#351;kil
                edecek &#351;ekilde yorumlanmayacakt&#305;r. &#304;&#351;bu S&ouml;zle&#351;mede kullan&#305;lan madde
                ba&#351;l&#305;klar&#305; sadece kolayl&#305;k a&ccedil;&#305;s&#305;ndan eklenmi&#351; olup i&#351;bu
                S&ouml;zle&#351;menin herhangi bir maddesinin yorumlanmas&#305;nda dikkate al&#305;nmayacakt&#305;r. Kapsam
                aksini gerektirmedik&ccedil;e, i&#351;bu S&ouml;zle&#351;mede kullan&#305;ld&#305;&#287;&#305; &uuml;zere,
                tekil s&ouml;zc&uuml;kler &ccedil;o&#287;ullar&#305;, &ccedil;o&#287;ul s&ouml;zc&uuml;kler tekilleri
                i&ccedil;erir. &#304;&#351;bu S&ouml;zle&#351;mede kullan&#305;ld&#305;&#287;&#305; &uuml;zere
                &ldquo;dahil&rdquo; kelimesi bir s&#305;n&#305;rlay&#305;c&#305; kelime de&#287;ildir.
              </span>
            </p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4">
              <span className="c2">22.2.</span>
              <span className="c1">
                &nbsp;Taraflar&#305;n bu s&ouml;zle&#351;meden
                do&#287;an herhangi bir hakk&#305;n&#305; k&#305;smen veya tamamen kullanmamas&#305;, s&ouml;z konusu
                hakk&#305;n&#305; kullanmaktan a&ccedil;&#305;k veya &ouml;rt&uuml;l&uuml;, ge&ccedil;ici veya s&uuml;rekli
                olarak vazge&ccedil;ti&#287;i &#351;eklinde yorumlanamaz.
              </span>
            </p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4"><span className="c5 c2">MADDE 23&ndash; &#304;&#350; &#304;L&#304;&#350;K&#304;S&#304;</span></p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4">
              <span className="c1">
                &#304;&#351;bu S&ouml;zle&#351;me, burada a&ccedil;&#305;klanan h&uuml;k&uuml;mler
                haricinde, Taraflara herhangi bir hak ve y&uuml;k&uuml;ml&uuml;l&uuml;k getirmez, ayr&#305;ca; Taraflar
                a&ccedil;&#305;s&#305;ndan ortakl&#305;k veya resmi mahiyette ba&#351;ka bir i&#351;in kurulmas&#305;n&#305;
                ama&ccedil;lad&#305;&#287;&#305;, gelecekte ba&#351;ka bir s&ouml;zle&#351;me yap&#305;laca&#287;&#305;
                &#351;eklinde yorumlanamaz.
              </span>
            </p>
            <p className="c3"><span className="c5 c2" /></p>
            <p className="c4"><span className="c5 c2">MADDE 24 &ndash; TEBL&#304;GAT</span></p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4">
              <span className="c1">
                Bu s&ouml;zle&#351;me kapsam&#305;nda yap&#305;lacak ihbar ve tebli&#287;ler
                taraflar&#305;n yukar&#305;da belirtilen adreslerine yaz&#305;l&#305; olarak yap&#305;l&#305;r. Bu
                adreslerde meydana gelecek de&#287;i&#351;iklikler ilgili tarafa noter arac&#305;l&#305;&#287;&#305;yla,
                yaz&#305;l&#305; olarak bildirir. Aksi durumda bu adreslere yap&#305;lacak her t&uuml;rl&uuml;
                tebligat&#305;n ge&ccedil;erli olaca&#287;&#305;n&#305; kabul ve taahh&uuml;t etmi&#351;lerdir.
              </span>
            </p>
            <p className="c3"><span className="c5 c2" /></p>
            <p className="c4"><span className="c5 c2">MADDE 25&ndash; TAMAMLAYICI H&Uuml;K&Uuml;MLER</span></p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4">
              <span className="c1">
                &#304;&#351;bu s&ouml;zle&#351;mede h&uuml;k&uuml;m bulunan konular &ouml;ncelikle ve
                &ouml;zellikle ge&ccedil;erlili&#287;ini koruyacak; s&ouml;zle&#351;mede h&uuml;k&uuml;m bulunmayan
                konularda T&uuml;rk Bor&ccedil;lar Kanunu, T&uuml;rk Medeni Kanunu, T&uuml;rk Ticaret Kanunu, Rekabetin
                Korunmas&#305; Hakk&#305;nda Kanun ve ilgili mevzuat ge&ccedil;erli olacakt&#305;r.
              </span>
            </p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4"><span className="c5 c2">MADDE 26 &ndash; S&Ouml;ZLE&#350;MEN&#304;N D&#304;L&#304;</span></p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4"><span className="c1">S&ouml;zle&#351;menin dili T&uuml;rk&ccedil;e&rsquo;dir.</span></p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4"><span className="c5 c2">MADDE 27 &ndash; UYGULANACAK HUKUK VE YETK&#304;L&#304; MAHKEME</span></p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4" id="h.1fob9te">
              <span className="c1">
                &#304;&#351;bu s&ouml;zle&#351;menin yorumunda ve i&#351;bu
                s&ouml;zle&#351;me sebebiyle ortaya &ccedil;&#305;kacak olan t&uuml;m uyu&#351;mazl&#305;klarda
                &#304;stanbul (&Ccedil;a&#287;layan) mahkemeleri ve icra daireleri yetkili olup, T&uuml;rk hukuku
                uygulan&#305;r.

              </span>
            </p>
            <p className="c3"><span className="c5 c2" /></p>
            <p className="c4"><span className="c5 c2">MADDE 28 &ndash; Y&Uuml;R&Uuml;RL&Uuml;K</span></p>
            <p className="c3"><span className="c1" /></p>
            <p className="c4">
              <span className="c1">
                11 sahifede 28 maddeden ibaret olan i&#351;bu s&ouml;zle&#351;me t&uuml;m maddeleri,
                sayfalar&#305; ile bir b&uuml;t&uuml;n olup taraflarca okunmu&#351;, anla&#351;&#305;lm&#305;&#351;,
                h&uuml;r iradeleriyle kabul edilerek, 2(iki) as&#305;l n&uuml;sha olarak taraflar&#305;n &uuml;yelik
                sipari&#351; formu imza tarihinde y&uuml;r&uuml;rl&uuml;&#287;e girmi&#351;tir.
              </span>
            </p>

            <p className="c4"><span className="c1">Son Güncellenme Tarihi : 21.05.2021</span></p>

          </div>

        </Grid>
      </Grid>

    </>
  )
}
export default SartlarVeKosullar
